export default {
    address: {
        city: "Місто",
        city_locality: "Місто \/ Населений пункт",
        country: "Країна",
        line1: "Рядок адреси 1",
        line2: "Рядок адреси 2",
        postal_code: "Поштовий індекс",
        state: "Штат",
        state_region: "Штат \/ Регіон"
    },
    alerts: {
        account_2fa: "Захистіть свій обліковий запис за допомогою двофакторної автентифікації.",
        account_2fa_success: "Двофакторну автентифікацію ввімкнено.",
        activate_instruction: "Увімкнення автоматичного збору відгуків призведе до спроби надіслати запит на відгук до {count}. Перегляньте свої шаблони перед увімкненням.",
        activate_intro: "Постійно запитуйте відгуки відповідно до вашої стратегії.",
        agency_mcp_server: "Підключіть Claude або будь-якого клієнта MCP до сервера MCP вашого агентства. Авторизовані помічники можуть керувати проектами, клієнтами та командою вашого агентства від вашого імені.",
        agency_sso: "Підключіть постачальника ідентифікаційних даних OpenID Connect для входу клієнта.",
        ai_assistant: "Для використання штучного інтелекту для пропозицій відгуків та відповідей обов’язкові назва та опис вашої компанії.",
        ai_location_instructions: "Додаються до користувацьких інструкцій вище й використовуються лише для вибраного розташування.",
        ai_review_pages: "Дозвольте пропозиції відгуків ШІ на вибраних сторінках.",
        api_key_roll: "Ви впевнені, що хочете змінити свій ключ API? Це вплине на будь-яку програму, яка його використовує.",
        ask_confirm: "Ви впевнені, що хочете надіслати запит на відгуки від {count}? Це запланує запити для всіх клієнтів, яким ще не було надіслано запит.",
        automate_highlights: "Автоматично виділяйте фрази в нових позитивних відгуках.",
        automate_replies: "Автоматично публікуйте відповіді ШІ на нові відгуки Google і Facebook. Потрібна [інтеграція Google або Facebook](\/settings\/integrations?tab=review).",
        cname_delete: "Ви впевнені, що хочете видалити CNAME: {cname_name}?",
        cname_not_configured: "Цей запис ще не налаштовано. Зачекайте...",
        cname_warning: "Повідомлення, які вже було надіслано вашим клієнтам, матимуть непрацюючі посилання.",
        connection_disabled: "З’єднання вимкнено. Будь ласка, під’єднайтеся знову.",
        customer_archive: "Ви впевнені, що хочете архівувати клієнта: {customer_name}? Усі ненадіслані повідомлення будуть скасовані.",
        customer_cancel: "Ви впевнені, що хочете скасувати всі ненадіслані повідомлення для клієнта: {customer_name}?",
        customer_ingest: "Вкажіть цю адресу електронної пошти в полі «BCC» під час надсилання електронних листів вашим клієнтам, щоб їхнє ім’я та адреса електронної пошти імпортувалися автоматично.",
        customer_resubscribe: "Ви впевнені, що хочете повторно підписатися на клієнта: {customer_name}?",
        customer_unarchive: "Ви впевнені, що хочете розархівувати клієнта: {customer_name}?",
        customer_unsubscribe: "Ви впевнені, що хочете скасувати підписку для клієнта: {customer_name}?",
        customer_unsubscribe_all: "Ви впевнені, що хочете скасувати підписку {count} на отримання повідомлень від цього проєкту?",
        delete: "Ви впевнені, що хочете видалити {model}: {name}?",
        delete_count: "Ви впевнені, що хочете видалити {count}?",
        domain_agency: "Додайте власний домен відправника, щоб повністю використовувати білий лейбл вашого агентства.",
        domain_delete: "Ви впевнені, що хочете видалити домен: {name}? Ми продовжуватимемо надсилати електронні листи з нашого власного доменного імені.",
        domain_dmarc: "Додайте запис DMARC до свого домену, щоб зменшити ймовірність потрапляння електронних листів у спам.",
        domain_project: "Додайте домен відправника, щоб ми могли надсилати електронні листи вашим клієнтам з вашого власного доменного імені.",
        export_confirm: "Ви впевнені, що хочете експортувати всі ваші {model}?",
        export_count: "Ви впевнені, що хочете експортувати {count}?",
        export_link: "Посилання для завантаження буде надіслано на адресу {email} невдовзі після того, як ви зробите запит.",
        highlights_save_disabled: "Ви можете за бажанням видалити основні моменти з усіх відгуків, які їх зараз мають.",
        highlights_save_enabled: "Щоб створювати виділення для всіх позитивних відгуків, поставте позначку у відповідному полі нижче. Якщо ви змінюєте лише колір виділення, не позначте цей прапорець.",
        integration_disconnect: "Ви впевнені, що хочете відключитися від {integration_name}?",
        integration_sync: "Ви впевнені, що хочете синхронізувати свій обліковий запис {integration_name}? Ми постійно імпортуватимемо ваші дані.",
        intro: "Почніть з імпорту клієнтів. Потім надішліть запити на відгук самостійно або дозвольте нам надіслати їх за вас.",
        intro_help: "Якщо потрібна допомога, {demo}.",
        logout: "Ви впевнені, що хочете вийти?",
        mcp_server: "Підключіть Claude або будь-якого клієнта MCP до цього проєкту. сервер MCP дозволяє помічникам зі штучним інтелектом читати та керувати відгуками, клієнтами та повідомленнями від вашого імені.",
        member_confirm: "Ви впевнені, що хочете видалити себе? Ви втратите доступ до цього проєкту.",
        member_confirm_all: "Ви впевнені, що хочете видалити себе? Ви втратите доступ до всіх своїх проектів.",
        member_other_confirm: "Ви впевнені, що хочете видалити {noun}: {name}? Вони втратять доступ до цього проєкту.",
        member_other_confirm_all: "Ви впевнені, що хочете видалити {noun} {name}? Вони втратять доступ до всіх своїх проектів.",
        message_cancel: "Ви впевнені, що хочете скасувати це повідомлення?",
        message_cancel_all: "Ви впевнені, що хочете скасувати {count}? Цю дію можна виконати лише з ненадісланими повідомленнями.",
        message_delete: "Ви впевнені, що хочете видалити це повідомлення?",
        oauth_client_revoke: "Ви впевнені, що хочете скасувати доступ для {client}? Будь-які активні сеанси будуть негайно розірвані.",
        project_summary: "Наразі неможливо створити зведення.",
        project_suspend: "Ви впевнені, що хочете призупинити проєкт: {project_name}?",
        project_unsuspend: "Ви впевнені, що хочете розблокувати проєкт: {project_name}?",
        review_delete: "Ви впевнені, що хочете видалити цей відгук? Цю дію не можна скасувати.",
        review_page_confirm: "Ви впевнені, що хочете зберегти зміни?",
        review_page_confirmation: "Показуйте повідомлення з підтвердженням на сторінці успіху залежно від вибраної оцінки.",
        review_page_default: "Ви впевнені, що хочете зробити сторінку Відгуку: {name} сторінкою за замовчуванням? Ця сторінка буде використана, якщо запиту на Відгук не призначено жодної іншої сторінки.",
        review_page_delete: "Ви впевнені, що хочете видалити сторінку відгуку: {name}? Усі клієнти, які зараз перенаправляються на цю сторінку, будуть перенаправлені на вашу сторінку за замовчуванням.",
        review_page_delete_all: "Ви впевнені, що хочете видалити {count}? Вашу сторінку Відгуку за замовчуванням не буде видалено.",
        review_page_fields: "Використовуйте поля для збору інформації про клієнтів під час залишення відгуку. Додайте більше полів до форми та умовно відображайте їх, коли клієнти вибирають оцінку.",
        review_page_instructions: "Відображати інструкції безпосередньо над формою після вибору оцінки.",
        review_page_location_picker: "Дозвольте клієнтам вибрати будь-яке місце у вашому проєкті для Відгуку. Це буде попередньо вибрано, якщо сторінка Відгуку має відображатися для певного місця.",
        review_page_locations: "Виберіть місця, які мають використовувати цю сторінку Відгуку. Місцезнаходження можна призначити лише одній сторінці Відгуку. Якщо місцезнаходження не призначено, використовуватиметься сторінка Відгуку за замовчуванням.",
        review_page_redirects: "Пропустіть форму після вибору оцінки та перенаправте на інше місце. Ви також можете розділити трафік на кілька веб-сайтів, додавши більше одного перенаправлення для кожної оцінки.",
        review_page_review_suggestions: "Допоможіть клієнтам писати відгуки за допомогою готових пропозицій, які вони можуть відредагувати перед надсиланням.",
        share_template_delete: "Ви впевнені, що хочете видалити шаблон спільного доступу \"{name}\"? Цю дію неможливо скасувати.",
        smtp_remove: "Ви впевнені, що хочете видалити конфігурацію SMTP зі свого проєкту? Ваш домен відправника повернеться до стандартної конфігурації.",
        smtp_setup: "Надсилайте електронні листи з власного поштового сервера. Введіть свої облікові дані SMTP. Якщо ваш сервер використовує обмеження IP-адрес, будь ласка, додайте до білого списку такі IP-адреси, які використовуються нашою системою: {ips}.",
        space_delete: "Ви впевнені, що хочете видалити простір: {name}? Усі проекти всередині нього будуть видалені.",
        tag_rule: "Додайте позитивний термін та його негативний аналог. Якщо він підходить, ми за допомогою штучного інтелекту автоматично позначатимемо відгук одним або іншим тегом.",
        user_delete: "Ви впевнені, що хочете видалити обліковий запис користувача: {email}?",
        user_verify: "Щоб підтвердити свою адресу електронної пошти та активувати обліковий запис, натисніть посилання в електронному листі, надісланому на адресу: {email}.",
        widget_delete: "Ви впевнені, що хочете видалити віджет: {name}? Віджет більше не відображатиметься на жодному вебсайті.",
        widget_restore: "Ви впевнені, що хочете відновити налаштування віджета: {name}? Повернеться лише дизайн до значень за замовчуванням.",
        widgets_1: "Додайте цей скрипт до основної частини вашого веб-сайту.",
        widgets_2: "Стіна відгуків відображає всі ваші відгуки у вигляді сітки. Додайте цей скрипт там, де має відображатися віджет.",
        widgets_3: "Відгук у фокусі демонструє один великий відгук. Додайте цей скрипт там, де має відображатися віджет."
    },
    billing_statuses: {
        active: "Ваша підписка активна.",
        canceled: "Вашу підписку скасовано. Будь ласка, оновіть підписку, щоб продовжити.",
        ending: "Ваша підписка закінчується {date}.",
        trial: "Ваш безкоштовний пробний період закінчується {date}.",
        trial_expired: "Термін дії вашої безкоштовної пробної версії закінчився. Будь ласка, оновіть підписку, щоб продовжити.",
        trial_expiring: "Термін дії вашої безкоштовної пробної версії незабаром закінчується. Будь ласка, оновіть її, щоб продовжити."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "Електронна пошта",
        facebook: "Фейсбук",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Реддіт",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Теми",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "Х",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Додайте домен відправника, щоб редагувати свою адресу електронної пошти:",
        agency_robots: "Дозвольте пошуковим системам індексувати ваш клієнтський портал.",
        analytics_average_review: "Середня оцінка в зірках за цей період.",
        analytics_customers: "Додані клієнти та клієнти, яких уперше попросили залишити відгук.",
        analytics_limits: "Запити на відгук сьогодні та цього місяця.",
        analytics_location_leaderboard: "Кількість відгуків, середня оцінка та відсоток 5 зірок за локацією.",
        analytics_needs_attention: "Відгуки на 1 і 2 зірки за останні 3 місяці без відповіді.",
        analytics_outreach: "Надіслані, клікнуті та невдалі повідомлення з часом.",
        analytics_reply_coverage: "Відсоток відгуків, що мають відповідь.",
        analytics_review_velocity: "Середня кількість відгуків на тиждень.",
        analytics_review_volume: "Скільки відгуків ви отримали за цей період.",
        analytics_sentiment: "Письмові відгуки, оцінені як позитивні, нейтральні або негативні.",
        analytics_source_mix: "Кількість відгуків і середня оцінка за джерелом.",
        analytics_star_mix: "Кількість відгуків у часі за зірковою оцінкою.",
        analytics_tags: "Найуживаніші теги за цей період, з кількістю та середнім.",
        ai_business_description: "Детальний опис вашого бізнесу, який допоможе у створенні пропозицій щодо відгуків та відповідей.",
        ai_business_name: "Назва вашого бізнесу.",
        ai_highlights: "Виділяйте найкращі фрази з позитивних відгуків.",
        ai_highlights_instructions: "Скажіть ШІ, які фрази надавати перевагу у виділеннях.",
        ai_replies: "Чернетки відповідей на відгуки з можливістю автоматизації.",
        ai_reply_contact: "Додається до відповідей на негативні відгуки.",
        ai_reply_instructions: "Скажіть ШІ, як мають звучати відповіді та що в них включати.",
        ai_review_instructions: "Скажіть ШІ, що згадувати або уникати в пропозиціях відгуків.",
        ai_review_suggestions: "Допоможіть клієнтам писати відгуки за готовими пропозиціями.",
        ai_tags: "Автоматично тегуйте відгуки, що відповідають вашим інструкціям.",
        ask_location: "Місце, яке потрібно призначити для Відгуку.",
        ask_review_page: "Сторінка для запису відгуку.",
        assign_tags: "Призначте теги до Відгуку.",
        csv_max_rows: "До {count} рядків",
        dashboard_configure_settings: "Налаштуйте параметри вашого проєкту.",
        dashboard_import_customers: "Імпортуйте своїх клієнтів.",
        dashboard_preview_email_templates: "Перегляньте шаблони електронних листів.",
        dashboard_preview_kiosk_page: "Попередній перегляд сторінки вашого кіоску.",
        dashboard_preview_review_page: "Перегляньте сторінку вашого Відгуку.",
        dashboard_preview_showcase_page: "Попередній перегляд сторінки вашої вітрини.",
        detect_from_website: "Залиште поле порожнім, щоб виявляти з вебсайту.",
        logo_height: "Висота логотипу в електронних листах та на сторінках.",
        meta_description: "Перевизначити опис сторінки.",
        meta_title: "Перевизначити заголовок сторінки.",
        mfa_password: "Введіть пароль свого облікового запису.",
        mfa_qr_code: "Відскануйте QR-код за допомогою програми автентифікатора.",
        mfa_security_code: "Введіть код із вашого застосунку для автентифікації.",
        mcp_server_url: "Вставте цю URL в Claude, ChatGPT або будь-який MCP клієнт.",
        other_website_url: "Вимоги:<br>Рейтинг: від 1 до 5 зірок<br>Дата: протягом останніх 2 років<br>Тільки публічні сторінки",
        override_ambassador: "Розміщуйте значок в електронних листах, на сторінках та у віджетах ваших клієнтів.",
        project_name: "Назва вашого бізнесу, бренду або вебсайту.",
        project_robots: "Дозвольте пошуковим системам індексувати ваші сторінки з відгуками та демонструвати їх.",
        project_slug: "Використовується в електронних листах та посиланнях для клієнтів, якщо не налаштовано CNAME.",
        qr_fallback_redownload: "Завантажте код ще раз після додавання цього.",
        qr_fallback_url: "Використовується, якщо проєкт призупинено або видалено.",
        review_page_copied_message: "Показується після надсилання позитивного відгуку.",
        review_page_email_address: "Отримуйте відгуки на цю електронну адресу.",
        review_page_link_reveal_position: "Де розкривати посилання.",
        review_page_link_revealer_label: "Мітка для відображення посилань.",
        review_page_link_revealer_rating: "Показувати посилання, якщо клієнт вибирає цей або вищий рейтинг, інакше показувати кнопку для їх відображення.",
        review_page_native_reviews: "Дозволити відгуки на цій платформі.",
        review_page_rating_selection: "Зберегти оцінку перед надсиланням відгуку.",
        review_page_success_button_link: "Якщо поле порожнє, посилання за замовчуванням веде на веб-сайт вашого проєкту, інакше – на домен сторінки.",
        review_page_warning: "Якщо ви забороните клієнтам залишати публічні відгуки, ваш бізнес може бути видалений.",
        review_reply_status: "Ми не можемо публічно відповісти на цей відгук. Ви можете зв’язатися безпосередньо з автором відгуку.",
        scrape_facebook_url: "Вимоги:<br>До 100 нещодавніх відгуків<br>Тільки загальнодоступні сторінки",
        scrape_linkedin_url: "Вимоги:<br>Тільки рекомендації<br>Тільки публічні сторінки",
        scrape_trustpilot_url: "Вимоги:<br>Рейтинг: від 1 до 5 зірок<br>Тільки публічні сторінки",
        separate_with_commas: "Розділіть кілька комами.",
        setup_basics: "Налаштуйте, коли та як ви просите клієнтів про відгуки.",
        setup_business: "Розкажіть нам, під яким ім'ям вас знають клієнти.",
        setup_google: "Надсилайте клієнтів до свого профілю Google , відповідайте на відгуки та імпортуйте існуючі. Ви можете пропустити цю функцію та зробити це пізніше.",
        setup_location_limit: "Ваша пробна версія включає 1 місцезнаходження. Оновіть підписку будь-коли, щоб синхронізувати більше.",
        showcase_locations: "Обмежте вітрину певними місцями.",
        showcase_review_length: "Відгуки повинні містити щонайменше стільки символів.",
        showcase_since: "Показати відгуки, створені до цієї дати або раніше.",
        showcase_sources: "Обмежте вітрину певними джерелами.",
        showcase_tags: "Обмежте вітрину відгуками з певними тегами.",
        signature_html: "Скопіюйте та вставте підпис у свою поштову програму.",
        signed_up: "Дата початку роботи клієнта.",
        twilio_webhook: "Встановіть як URL зворотного виклику для вашої служби обміну повідомленнями.",
        widget_embed: "Необов’язково. ID наявного елемента, де має з’явитися Widget.",
        widget_wordpress: "Встановіть плагін, а потім вставте цей Shortcode туди, де має з’явитися Widget."
    },
    labels: {
        accept_all: "Прийняти все",
        access_code: "Код доступу",
        access_codes: "Коди доступу",
        account: "Обліковий запис",
        account_sid: "SID облікового запису",
        action: "Дія",
        actions: "Дії",
        activate: "Активувати",
        active: "Активний",
        add: "Додати",
        add_agency_project: "Додати проєкт агентства",
        add_confirmation_message: "Додайте повідомлення з підтвердженням.",
        add_css_rules: "Додайте власні правила CSS.",
        add_custom_field: "Додати власне поле",
        add_customer: "Додати клієнта",
        add_customers_with: "Додати клієнтів за допомогою {model}",
        add_external_link: "Додати зовнішнє Посилання",
        add_external_links: "Додати зовнішні Посилання",
        add_introduction: "Додайте вступ.",
        add_js_tags: "Додайте власні теги JavaScript.",
        add_legal_information: "Додайте юридичну інформацію.",
        add_location: "Додати місцезнаходження",
        add_project: "Додати проєкт",
        add_review: "Додати Відгук",
        add_source: "Додати джерело",
        add_tag: "Додати Тег",
        added: "Додано",
        address: "Адреса",
        advanced_review_pages: "Сторінки відгуків",
        affiliates: "Партнери",
        age_of_reviews: "Вік Відгуки",
        agencies: "Агентства",
        agency: "Агентство",
        agency_name: "Назва агентства",
        agency_project: "Проект агентства",
        agency_projects: "Проєкти агентства",
        ai: "Штучний інтелект",
        ai_answers: "Відповіді ШІ",
        ai_assistant: "Помічник зі штучним інтелектом",
        ai_auto_tagging: "Тегування ШІ",
        ai_highlights_instructions: "Приклад: Надавай перевагу фразам про сервіс або наш бренд.",
        ai_reply_instructions: "Приклад: Тримай відповіді короткими. Запрошуй зв’язатися при негативі.",
        ai_review_instructions: "Приклад: Згадай персонал і візит. Не згадуй ціни.",
        ai_review_suggestions: "Пропозиції відгуків ШІ",
        ai_reviews_and_replies: "Пропозиції та відповіді щодо Відгуку ШІ",
        ai_tagging_instructions: "Приклад: Застосовуйте до відгуків, у яких згадується час очікування, повільне обслуговування або затримки.",
        ai_tags: "Теги ШІ",
        ai_tools: "Інструменти ШІ",
        all: "Усі",
        allowed_domains: "Дозволені домени",
        amount: "Сума",
        analytics: "Аналітика",
        and: "і",
        anonymous_reviews: "Анонімні Відгуки",
        answer: "Відповідь",
        any: "Будь-який",
        api: "API",
        api_key: "Ключ API",
        appearance: "Зовнішній вигляд",
        apply: "Застосувати",
        approved: "Схвалено",
        archive: "Архів",
        archive_customer: "Архів клієнта",
        archived: "Архівовано",
        at_least: "принаймні",
        at_least_days: "Принаймні {num} днів",
        at_least_hours: "Принаймні {num} годин",
        at_least_months: "Принаймні {num} місяців",
        at_most: "щонайбільше",
        at_most_days: "Не більше {num} днів",
        at_most_hours: "Не більше {num} годин",
        at_most_months: "Не більше {num} місяців",
        auth_token: "Маркер автентифікації",
        authorize: "Авторизувати",
        auto_detect: "Авто",
        auto_tags: "Теги ШІ",
        automate: "Автоматизувати",
        automate_highlights: "Автоматизувати виділення",
        automate_replies: "Автоматизувати відповіді",
        automatic_review_collection: "Автоматичний збір відгуків",
        automatically_apply_tags: "Автоматично застосовувати тег до наявних відгуків",
        automating: "Автоматизація",
        avatar: "Аватар",
        avatars: "Аватари",
        average_charge: "Середній платіж",
        average_review: "Середній Відгук",
        background_color: "Колір фону",
        background_image: "Фонове зображення",
        back: "Назад",
        bcc: "BCC",
        bcc_email_address: "Адреса електронної пошти для BCC",
        best_to_worst: "Від найкращого до найгіршого",
        billing: "Виставлення рахунків",
        blog: "The Reviews Guy",
        body: "Текст",
        body_font_size: "Розмір шрифту Текст",
        bold: "Жирний",
        book_a_demo: "Замовити демо",
        bottom: "Дно",
        bottom_left: "Внизу ліворуч",
        bottom_right: "Внизу праворуч",
        build_on: "Створити на {model}",
        business: "Business",
        business_description: "Опис бізнесу",
        business_email: "Адреса електронної пошти служби підтримки",
        business_name: "Назва компанії",
        business_phone: "Номер телефону служби підтримки",
        business_website: "Вебсайт бізнесу",
        button: "Кнопка",
        button_label: "Мітка для Кнопка",
        button_link: "Посилання для Кнопка",
        button_position: "Положення Кнопка",
        button_size: "Розмір Кнопка",
        buy_me_a_coffee: "Купи мені кави",
        by: "від",
        by_signing_up: "Створюючи обліковий запис, ви погоджуєтеся з нашими",
        call_to_action: "Заклик до дії",
        cancel: "Скасувати",
        cancel_1_message: "Скасувати 1 повідомлення",
        cancel_message: "Скасувати повідомлення",
        cancel_messages: "Скасувати {count} Повідомлення",
        cancel_subscription: "Скасувати підписку",
        cancel_unsent_messages: "Скасувати невідправлені повідомлення",
        canceled: "Скасовано",
        center: "Центр",
        change: "Зміна",
        change_key: "Змініть свій ключ API",
        change_plan: "Змінити план",
        changelog: "Список змін",
        channel: "Канал",
        channels: "Канали",
        characters: "Символи",
        charges_avg: "Середній платіж має бути щонайменше",
        charges_count: "Кількість списань має бути щонайменше",
        charges_sum: "Загальна сума платежів має бути щонайменше",
        chat_with_us: "Напишіть нам",
        chatgpt: "ChatGPT",
        checkbox: "Прапорець",
        claude: "Клод",
        clear: "Очистити",
        clear_highlights_from_reviews: "Видалити виділення з усіх відгуків",
        clicked: "Натиснуто",
        client: "Клієнт",
        client_id: "Client ID",
        clients: "Клієнти",
        close: "Закрити",
        cloudflare_warning: "Якщо ви користуєтеся Cloudflare, ваш проксі-сервер має бути вимкнений.",
        cname: "CNAME",
        cname_setup_incomplete: "Налаштування не завершено – буде видалено {date}",
        cname_ssl_pending: "Очікування SSL-сертифіката",
        cname_status_for: "Статус CNAME для",
        code_editor: "Редактор коду",
        collapse: "Згорнути",
        collect_reviews_anywhere: "Збирайте відгуки будь-де",
        color: "Колір",
        colors: "Кольори",
        commission_rate: "Комісійна ставка",
        commission_status_approved: "Схвалено",
        commission_status_paid: "Платно",
        commission_status_pending: "Очікує на розгляд",
        commission_status_reversed: "Зворотне",
        community: "Громада",
        company: "Компанія",
        complained: "Скарги",
        confirm_new_password: "Підтвердіть новий пароль",
        confirmation_message: "Підтверджувальне повідомлення",
        configure: "Налаштувати",
        connect: "Підключитися",
        connect_bank: "Підключити банківський рахунок",
        connect_google: "Підключити Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Підключено",
        consent_preferences: "Налаштування згоди",
        contact_customer: "Зв'язатися з клієнтом",
        contact_form: "Контактна форма",
        contact_support: "Будь ласка, зверніться до служби підтримки.",
        contact_us: "Зв'яжіться з нами",
        container_element: "Елемент контейнера",
        context: "Контекст",
        continue: "Продовжити",
        continue_with_google: "Продовжити з Google",
        cookie_category_analytics: "Аналітика",
        cookie_category_essential: "Основне",
        cookie_category_functional: "Функціональний",
        cookie_category_marketing: "Маркетинг",
        cookie_consent_banner: "Банер згоди на використання файлів cookie",
        cookie_consent_scope_all: "Показати всім",
        cookie_consent_scope_eea: "Показувати лише відвідувачам ЄЕЗ та Великої Британії",
        cookie_consent_scope_none: "Не показувати",
        cookie_policy: "Політика щодо файлів cookie",
        cookie_preference: "Налаштування файлів cookie",
        copied: "Скопійовано",
        copied_message: "Скопійоване повідомлення",
        copy: "Копіювати",
        copy_embed_code: "Скопіювати код вбудовування",
        copy_signature: "Копія Підпис",
        copy_source_code: "Скопіювати вихідний код",
        copy_to_all_ratings: "Копіювати до всіх оцінок",
        copy_uuid: "Копіювати UUID",
        create: "Створити",
        create_account: "Створити обліковий запис",
        create_agency: "Створити агентство",
        create_cname: "Створіть запис CNAME та вкажіть його на",
        create_external_link: "Створити зовнішнє Посилання",
        create_field: "Створити поле",
        create_link: "Створити Посилання",
        create_location: "Створити місцезнаходження",
        create_project: "Створити проєкт",
        create_qr_code: "Створити QR-код",
        create_review: "Створити Відгук",
        create_review_page: "Створити сторінку відгуку",
        create_signature: "Створіть підпис",
        create_source: "Створити джерело",
        create_space: "Створити робочий простір",
        create_tag: "Створити Тег",
        create_tag_rule: "Створення правила Тег",
        create_webhook: "Створіть вебхук",
        create_widget: "Створити віджет",
        created_with_ai_based_on_recent_reviews: "Створено ШІ на основі нещодавніх відгуків",
        crms: "CRM-системи",
        csv: "CSV",
        currency: "Валюта",
        current_plan: "Поточний план",
        current_year: "Поточний рік",
        custom_field: "Налаштовуване поле",
        custom_instructions: "Користувацькі інструкції",
        custom_url: "Користувацька URL",
        customer: "Клієнт",
        customer_name_convention: "Домовленість про імена клієнтів",
        customer_reviews: "Відгуки клієнтів",
        customers: "Клієнти",
        customize: "Налаштувати",
        customize_review_page: "Налаштувати Сторінка відгуків",
        daily: "Щоденно",
        daily_email_requests: "Щоденні запити електронною поштою",
        daily_limit: "Добовий ліміт",
        daily_requests: "Щоденні запити",
        daily_sms_requests: "Щоденні SMS запити",
        dark: "Темний",
        dashboard: "Панель керування",
        date: "Дата",
        date_added: "Дата додавання",
        date_canceled: "Дата скасування",
        date_clicked: "Дата кліку",
        date_complained: "Дата подання скарги",
        date_delivered: "Дата доставки",
        date_failed: "Дата невдачі",
        date_messaged: "Дата повідомлення",
        date_opened: "Дата відкриття",
        date_replied: "Дата відповіді",
        date_requested: "Дата запиту",
        date_reviewed: "Дата Опубліковано",
        date_scheduled: "Запланована дата",
        date_sent: "Дата відправлення",
        date_signed_up: "Дата реєстрації",
        date_updated: "Дата оновлення",
        dates: "Дати",
        day: "День",
        days: "Дні",
        days_after_last_request: "днів після останнього запиту",
        days_later: "днів пізніше",
        deactivate: "Деактивувати",
        default: "За замовчуванням",
        default_language: "Мова за замовчуванням",
        default_review_page: "Сторінка відгуків за замовчуванням",
        default_review_visibility: "Видимість Відгук за замовчуванням",
        default_tone: "Тон за замовчуванням",
        delay: "Затримка",
        delete: "Видалити",
        delete_1_customer: "Видалити 1 клієнта",
        delete_1_review: "Видалити 1 Відгук",
        delete_1_review_page: "Видалити 1 Сторінка відгуку",
        delete_1_widget: "Видалити 1 віджет",
        delete_agency: "Видалити агентство",
        delete_custom_field: "Видалити настроюване поле",
        delete_customer: "Видалити клієнта",
        delete_customers: "Видалити клієнтів",
        delete_external_link: "Видалити зовнішнє Посилання",
        delete_field: "Видалити поле",
        delete_link: "Видалити Посилання",
        delete_location: "Видалити місцезнаходження",
        delete_message: "Видалити повідомлення",
        delete_n_customers: "Видалити клієнтів {count}",
        delete_n_review_pages: "Видалити Сторінки відгуків {count}",
        delete_n_reviews: "Видалити Відгуки {count}",
        delete_n_widgets: "Видалити віджети {count}",
        delete_project: "Видалити проєкт",
        delete_qr_code: "Видалити QR-код",
        delete_reply: "Видалити відповідь",
        delete_review: "Видалити Відгук",
        delete_review_page: "Видалити Сторінка відгуків",
        delete_review_pages: "Видалити Сторінки відгуків",
        delete_reviews: "Видалити Відгуки",
        delete_signature: "Видалити Підпис",
        delete_source: "Видалити джерело",
        delete_space: "Видалити робочий простір",
        delete_tag: "Видалити Тег",
        delete_tag_rule: "Видалити правило Тег",
        delete_template: "Видалити шаблон",
        delete_user: "Видалити користувача",
        delete_webhook: "Видалити вебхук",
        delete_widget: "Видалити віджет",
        delete_widgets: "Видалити віджети",
        deleted: "Видалено",
        delivered: "Доставлено",
        description: "Опис",
        deselect_all: "Зняти вибір усіх",
        disable: "Вимкнути",
        disable_automatic_review_collection: "Вимкнути автоматичне збирання відгуків",
        disable_field: "Вимкнути поле",
        disable_when_links_are_visible: "Вимкнути, коли посилання видимі",
        disabled: "Вимкнено",
        disconnect: "Відключитися",
        disconnect_integration: "Відключення інтеграції",
        discord_community: "Спільнота Discord",
        display_name: "Відображуване ім'я",
        dmarc: "DMARC",
        dmarc_status_for: "Статус DMARC для",
        do_not_hide_from_public: "Не ховатися від громадськості",
        do_not_send: "Не надсилати",
        docs: "Документи",
        documentation: "Документація",
        domain: "Домен",
        domain_name: "Доменне ім'я",
        dont_have_an_account: "Немає облікового запису?",
        dont_send_thanks: "Не надсилайте подяки",
        done: "Готово",
        download: "Завантажити",
        download_plugin: "Завантажити плагін",
        download_records: "Завантажити записи",
        download_template: "Завантажити шаблон",
        dpa: "ДПА",
        dsar: "DSAR",
        dropdown: "Випадаючий список",
        duplicate: "Дублікат",
        duplicate_project: "Дублікат проекту",
        duplicate_review_page: "Дублікат Сторінка відгуків",
        duplicate_reviews: "Дублікати Відгуки",
        duplicate_widget: "Дублікат віджета",
        edit: "Редагувати",
        edit_1_customer: "Редагувати 1 клієнта",
        edit_1_review: "Редагувати 1 Відгук",
        edit_client: "Редагувати Клієнт",
        edit_custom_field: "Редагувати власне поле",
        edit_customer: "Редагувати клієнта",
        edit_customers: "Редагувати клієнтів",
        edit_field: "Редагувати поле",
        edit_link: "Редагувати Посилання",
        edit_location: "Редагувати місцезнаходження",
        edit_member: "Редагувати учасника",
        edit_n_customers: "Редагувати {count} Клієнти",
        edit_n_reviews: "Редагувати Відгуки {count}",
        edit_notes: "Редагувати нотатки",
        edit_qr_code: "Редагувати QR-код",
        edit_reviews: "Редагувати Відгуки",
        edit_signature: "Редагувати Підпис",
        edit_source: "Редагувати джерело",
        edit_strategy: "Редагувати стратегію",
        edit_tag: "Редагувати Тег",
        edit_tag_rule: "Редагувати правило Тег",
        edit_tags: "Редагувати теги",
        edit_team_member: "Редагувати учасника команди",
        edit_visibility: "Змінити видимість",
        edit_webhook: "Редагувати вебхук",
        editable_ratings: "Редаговані оцінки",
        earned: "Зароблено",
        eligible: "Відповідає вимогам",
        email: "Електронна пошта",
        email_address: "Адреса електронної пошти",
        email_validation_invalid: "Не вдалося перевірити електронну пошту",
        email_validation_passed: "Перевірка електронної пошти пройдена",
        email_validation_unknown: "Не вдалося підтвердити електронну пошту",
        emails: "Електронні листи",
        embed_code: "Вбудувати код",
        enable: "Увімкнути",
        enable_automatic_review_collection: "Увімкнути автоматичний збір відгуків",
        enable_for_all_reviews: "Увімкнути для всіх відгуків",
        enable_for_positive_reviews: "Увімкнути для позитивних відгуків",
        enable_on_review_pages: "Увімкнути на сторінках Відгуків",
        enabled: "Увімкнено",
        end: "Кінець",
        ends: "Закінчується",
        exclude: "Виключити",
        exclude_email: "Виключити електронну пошту",
        exclude_sms: "Виключити SMS",
        excluded_channels: "Виключені канали",
        expand: "Розгорнути",
        expired: "Термін дії минув",
        export: "Експорт",
        export_1_customer: "Експорт 1 клієнта",
        export_1_review: "Експорт 1 Відгук",
        export_all: "Експортувати все",
        export_all_customers: "Експортувати всіх клієнтів",
        export_all_reviews: "Експортувати всі Відгуки",
        export_customers: "Експортні клієнти",
        export_n_customers: "Експорт {count} Клієнти",
        export_n_reviews: "Експорт {count} Відгуки",
        export_reviews: "Експортні Відгуки",
        external_link: "Зовнішнє Посилання",
        external_links: "Зовнішні Посилання",
        extra_locations: "Додаткові локації",
        faces: "Обличчя",
        failed: "Не вдалося",
        fallback_url: "Резервна URL",
        feedback: "Зворотній зв'язок",
        feedback_form: "Форма відгуку",
        field: "Поле",
        fields: "Поля",
        filter: "Фільтр",
        first: "Перший",
        first_charged: "Перше стягнення",
        first_name: "Ім'я",
        first_name_last_initial: "Ім'я, прізвище, ініціал",
        five_star_share: "5 зірок %",
        flag_as_duplicate: "Позначити як дублікат",
        font: "Шрифт",
        font_family: "Сімейство шрифтів",
        font_size: "Розмір шрифту",
        footer: "Нижній колонтитул",
        for: "Для",
        forgot_password: "Забули пароль?",
        form: "Форма",
        free: "Безкоштовно",
        free_requests_included: "Безкоштовні запити включені",
        from: "з",
        full_name: "Повне ім'я",
        generate: "Згенерувати",
        generate_meta: "Згенерувати мета",
        generate_qr_code: "Згенерувати QR-код",
        generate_reply: "Згенерувати відповідь",
        generate_review: "Створити Відгук",
        generating: "Генерується",
        get_started: "Почати",
        get_started_checklist: "Контрольний список для початку",
        get_the_lifetime_deal: "Отримайте довічну пропозицію",
        getting_started: "Початок роботи",
        google_fonts: "Шрифти Google",
        grouped_by_request: "Згруповано за запитом",
        has_links: "Має Посилання",
        has_notes: "Має нотатки",
        has_redirects: "Має перенаправлення",
        have_an_account: "Маєте обліковий запис?",
        header: "Заголовок",
        hidden: "Прихований",
        hidden_from_search_engines: "Приховано від пошукових систем",
        hidden_reviews: "Приховані Відгуки",
        hide: "Приховати",
        hide_all_reviews: "Приховати всі відгуки",
        hide_avatar: "Приховати аватара",
        hide_date: "Приховати дату",
        hide_drop_shadow: "Приховати тінь",
        hide_field_label: "Приховати підпис поля",
        hide_from_public: "Приховати від публіки",
        hide_name: "Приховати ім'я",
        hide_pagination: "Приховати нумерацію сторінок",
        highlight_color: "Колір виділення",
        hipaa: "HIPAA",
        host: "Хост",
        hours: "Години",
        icon: "Значок",
        icon_size: "Розмір значка",
        icons: "Іконки",
        id: "ID",
        image: "Зображення",
        import: "Імпорт",
        import_address1: "Адреса клієнта, рядок 1.",
        import_address2: "Адреса клієнта, рядок 2.",
        import_city: "Місто або населений пункт клієнта.",
        import_company: "Назва компанії клієнта.",
        import_created_at: "Дата Відгуку.",
        import_customers: "Імпорт клієнтів",
        import_email: "Адреса електронної пошти клієнта.",
        import_first_name: "Ім'я клієнта.",
        import_from_boost_space: "Імпорт з Boost.space",
        import_from_hubspot: "Імпорт з HubSpot",
        import_from_make_com: "Імпорт з Make.com",
        import_from_pabbly: "Імпорт з Pabbly",
        import_from_stripe: "Імпорт із Stripe",
        import_from_zapier: "Імпорт із Zapier",
        import_last_name: "Прізвище клієнта.",
        import_list: "Список, розділений комами",
        import_notes: "Примітки лише для внутрішнього використання.",
        import_phone: "Номер телефону клієнта.",
        import_postal_code: "Поштовий індекс клієнта.",
        import_recent_reviews: "Імпортувати останні Відгуки",
        import_review: "Текст Відгуку.",
        import_reviews: "Відгуки імпорту",
        import_score: "Оцінка від 1 до 5.",
        import_signed_up_at: "Дата початку роботи клієнта.",
        import_slug: "слаг або UUID",
        import_state: "Штат або регіон клієнта.",
        import_yourself: "Імпортувати себе",
        incentive: "Стимул",
        include: "Включити",
        include_sample_reviews: "Додати зразки відгуки",
        incoming_webhook_url: "URL вхідного вебхука",
        inherit: "Успадкувати",
        initializing: "Ініціалізація",
        initials: "Ініціали",
        install_in: "Встановити в",
        insert_variable: "Вставити змінну",
        instructions: "Інструкції",
        integration: "Інтеграція",
        integrations: "Інтеграції",
        interval: "Інтервал",
        introduction: "Вступ",
        invite: "Запросити",
        invite_client: "Запросити Клієнт",
        invite_failed: "Запрошення не вдалося",
        invite_member: "Запросити учасника",
        invite_sent_to: "Запрошення надіслано",
        invite_team_member: "Запросити члена команди",
        invited: "Запрошено",
        issuer_url: "URL емітента",
        italic: "Курсив",
        joined: "Приєднався",
        key: "Ключ",
        keywords: "Ключові слова",
        keywords_in_replies: "Ключові слова у відповідях",
        keywords_in_reviews: "Ключові слова у Відгуки",
        kiosk_page: "Сторінка кіоску",
        label: "Мітка",
        label_font_size: "Розмір шрифту мітки",
        labels: "Мітки",
        language: "Мова",
        languages: "Мови",
        large: "Великий",
        last_12_months: "Останні 12 місяців",
        last_2_years: "Останні 2 роки",
        last_3_months: "Останні 3 місяці",
        last_4_weeks: "Останні 4 тижні",
        last_6_months: "Останні 6 місяців",
        last_charged: "Останнє стягнення плати",
        last_name: "Прізвище",
        layout: "Макет",
        leave: "Залишити",
        leave_project: "Вийти з проєкту",
        leave_space: "Вийти з робочого простору",
        left: "Ліворуч",
        let_clients_sign_in_with_sso: "Дозволити клієнтам входити через SSO",
        less: "менше",
        lifecycle_stage: "Етап життєвого циклу",
        lifetime_deal: "Довічна пропозиція",
        lifetime_deal_terms: "Умови довічної пропозиції",
        light: "Світло",
        limit: "Ліміт",
        limits: "Ліміти",
        link: "Посилання",
        link_color: "Колір посилання",
        link_reveal_position: "Позиція розкриття Посилання",
        link_revealer_button: "Кнопка відкриття Посилання",
        link_revealer_label: "Посилання розкриття посилання",
        link_revealer_rating: "Рейтинг розкриття Посилання",
        links: "Посилання",
        links_per_review_page: "Посилання на Сторінка відгуків",
        list: "Список",
        list_unsubscribe_headers: "Заголовки для List-Unsubscribe",
        load_more: "Завантажити більше",
        loading: "Завантаження",
        location: "Розташування",
        location_address: "Адреса розташування",
        location_name: "Назва місця розташування",
        location_picker: "Вибір місця розташування",
        locations: "Місця розташування",
        locations_limit: "Ліміт місць розташування",
        log_in: "Увійти",
        log_out: "Вийти",
        logo: "Логотип",
        logo_height: "Висота логотипу",
        long: "Довгий",
        lowest_rating: "Найнижчий рейтинг",
        ltd: "LTD",
        make_default: "Зробити за замовчуванням",
        manage: "Керувати",
        manage_limits: "Керування обмеженнями",
        manage_overrides: "Керування перевизначеннями",
        manage_payout_account: "Керування обліковим записом виплат",
        manage_subscription: "Керування підпискою",
        manual_entry: "Ручне введення",
        max: "Макс",
        max_size: "Максимальний розмір",
        maximum_characters: "Максимальна кількість Символи",
        maximum_customers: "Максимальна кількість клієнтів",
        maximum_locations: "Максимальна кількість місць розташування",
        maximum_members: "Максимальна кількість учасників",
        maximum_review_length: "Максимальна тривалість Відгук",
        maximum_tags: "Максимальна кількість Теги",
        maximum_widgets: "Максимальна кількість віджетів",
        mcp: "Сервер MCP",
        mcp_server: "Сервер MCP",
        mcp_server_url: "URL Сервер MCP",
        medium: "Середній",
        member: "Член",
        members: "Члени",
        menu: "Меню",
        message: "Повідомлення",
        message_link_expiration: "Термін дії Посилання для повідомлень",
        messaged: "Надіслано повідомлення",
        messages: "Повідомлення",
        messages_clicked: "Натиснуті повідомлення",
        messages_sent: "Надіслані повідомлення",
        messaging_service_sid: "SID служби обміну повідомленнями",
        min: "Хв",
        min_size: "Мінімальний розмір",
        minimal_delay: "Мінімальна затримка",
        minimum_characters: "Мінімальна кількість Символи",
        minutes: "Хвилини",
        month: "місяць",
        month_to_date: "Місяць до сьогодні",
        monthly: "Щомісяця",
        monthly_email_requests: "Щомісячні запити електронною поштою",
        monthly_limit: "Щомісячний ліміт",
        monthly_pricing_only: "Лише щомісячна ціна",
        monthly_request_limit: "Щомісячний ліміт запитів",
        monthly_requests: "Щомісячні запити",
        monthly_sms_requests: "Щомісячні SMS запити",
        months: "Місяці",
        months_free: "{count} Місяці безкоштовно",
        more: "більше",
        more_clients: "більше клієнтів",
        more_customers: "більше клієнтів",
        more_options: "Більше опцій",
        more_patients: "більше пацієнтів",
        more_reviews: "більше відгуків",
        more_reviews_needed: "Для підсумовування потрібно більше відгуків",
        more_users: "більше користувачів",
        more_visitors: "більше відвідувачів",
        most_negative: "Найбільш негативні",
        most_positive: "Найбільш позитивні",
        move: "Перемістити",
        moved: "Переміщено",
        name: "Ім'я",
        native_reviews: "Відгуки нативних користувачів",
        negative: "Негативний",
        negative_term: "Негативний термін",
        new: "Новий",
        new_password: "Новий пароль",
        newest: "Найновіші",
        neutral: "Нейтральний",
        no: "Ні",
        no_available_options: "Немає доступних опцій",
        no_credit_card_required: "Кредитна картка не потрібна",
        no_data_available: "Дані недоступні",
        no_reminders: "Не надсилати нагадування",
        no_retries: "Без повторних спроб",
        no_review: "Без відгуку",
        none: "Жоден",
        not_connected: "Не підключено",
        not_reviewed: "Не Опубліковано",
        notes: "Нотатки",
        notifications: "Сповіщення",
        now: "Зараз",
        n_1_ai_tag: "1 тег ШІ",
        n_1_review_page: "1 сторінка відгуків",
        n_ai_tags: "{count} теги ШІ",
        n_review_pages: "{count} сторінки відгуків",
        number_of_charges: "Кількість списань",
        number_of_reminders: "Кількість нагадувань",
        number_of_retries: "Кількість повторних спроб",
        number_of_review_suggestions: "Кількість пропозицій Відгук",
        of: "з",
        off: "Вимкнено",
        on: "Увімкнено",
        on_for_positive_reviews: "Увімкнено для позитивних відгуків",
        on_channel: "на каналі {channel}.",
        opened: "Відкрито",
        options: "Опції",
        or_log_in_with_email: "або увійдіть, використовуючи свою адресу електронної пошти",
        or_sign_up_with_email: "або скористайтеся своєю електронною адресою",
        other_website: "Інший веб-сайт",
        our_reviews: "Наші Відгуки",
        output: "Вихід",
        page_footer: "Нижній колонтитул сторінки",
        paid: "Платно",
        paragraph: "Абзац",
        password: "Пароль",
        past_month: "Минулий місяць",
        past_months: "Минулі {inc} місяці",
        past_week: "Минулий тиждень",
        past_year: "Минулий рік",
        past_years: "Минулі {inc} роки",
        paused: "Призупинено",
        payment_method: "Спосіб оплати",
        payout_status_completed: "Завершено",
        payout_status_pending: "Очікує на розгляд",
        pending: "Очікує на розгляд",
        pending_deployment: "Очікує розгортання",
        pending_validation: "Очікує перевірки",
        per_day: "на день",
        per_month: "на місяць",
        period: "Період",
        permissions: "Дозволи",
        phone: "Телефон",
        phone_number: "Номер телефону",
        pixels: "пікселі",
        placeholder: "Заповнювач",
        placement: "Розміщення",
        plan: "План",
        plan_bullet1: "Видаліть наш брендинг з електронних листів, сторінок та віджетів",
        plan_bullet2: "Використовуйте свій домен для сторінок, орієнтованих на клієнтів, та розсилки електронної пошти",
        plan_bullet3: "Зробіть продукт своїм за допомогою білого маркування для агентств",
        please_rate_our_service: "Будь ласка, оцініть наш сервіс",
        png: "PNG",
        policies: "Політики",
        positive: "Позитивний",
        popular: "Популярне",
        port: "Порт",
        position: "Позиція",
        positive_only: "Тільки позитивні Відгуки",
        positive_term: "Позитивний термін",
        powered_by: "Працює на",
        preview: "Попередній перегляд",
        preview_kiosk_page: "Переглянути сторінку кіоску",
        preview_review_page: "Переглянути сторінку відгуку",
        price: "Ціна",
        pricing: "Ціноутворення",
        primary_color: "Основний колір",
        priority: "Пріоритет",
        privacy_policy: "Політика конфіденційності",
        proceed_to_dashboard: "Перейти до Панель керування",
        product: "Продукт",
        profile: "Профіль",
        project: "Проєкт",
        project_name: "Назва проекту",
        setup_ask_delay: "Скільки часу потрібно чекати, перш ніж запитувати відгук",
        setup_reminders: "Скільки нагадувань надсилати",
        project_paused: "Цей проєкт призупинено.",
        project_suspended: "Цей проєкт призупинено.",
        project_website: "Вебсайт проекту",
        projects: "Проєкти",
        projects_limit: "Ліміт проектів",
        publish: "Опублікувати",
        publish_changes: "Опублікувати зміни на всіх інших сторінках Відгуку",
        published: "Опубліковано",
        purchase: "Купівля",
        qr_code: "QR-код",
        qr_code_name_placeholder: "Стіл 1, Стійка реєстрації",
        qr_codes: "QR-коди",
        quarter_to_date: "Квартал до сьогодні",
        quantity: "Кількість",
        query: "Запит",
        quick_import: "Швидкий імпорт",
        rating: "Рейтинг",
        rating_order: "Порядок оцінювання",
        rating_out_of: "рейтинг поза межами",
        rating_save_all: "Зберегти оцінку перед кожним відгуком",
        rating_save_customer: "Зберегти оцінку перед тим, як залишити відгук клієнта",
        rating_save_never: "Ніколи не зберегти оцінку перед написанням відгуку",
        rating_selection: "Вибір рейтингу",
        rating_selector: "Вибір рейтингу",
        ratings: "Рейтинги",
        read: "Читати",
        reapply_highlights_eligible: "Відновлюйте основні моменти за допомогою штучного інтелекту для всіх позитивних відгуки",
        reconnect: "Знову підключитися",
        redeem: "Використати",
        redirect_uri: "URI перенаправлення",
        redirects: "Перенаправлення",
        refer_and_earn: "Запросіть та заробіть",
        referral_billing_status_active: "Підписано",
        referral_billing_status_canceled: "Скасовано",
        referral_billing_status_trial: "Пробний",
        referral_billing_status_trial_expired: "Термін дії пробного періоду закінчився",
        referral_billing_status_trial_expiring: "Термін дії пробного періоду закінчується",
        referral_program: "Умови реферальної програми",
        referral_program_terms: "Умови реферальної програми",
        referrals: "Реферали",
        refresh: "Оновити",
        regenerate: "Регенерувати",
        reject_all: "Відхилити все",
        related_reviews: "Схожі Відгуки",
        related_similarity: "Подібність",
        remaining: "Залишок",
        reminder: "Нагадування",
        reminders: "Нагадування",
        remove: "Видалити",
        remove_client: "Видалити Клієнт",
        remove_cname: "Видалити CNAME",
        remove_domain: "Видалити домен",
        remove_from_project: "Видалити з проекту",
        remove_member: "Видалити учасника",
        remove_smtp_configuration: "Видалити конфігурацію SMTP",
        remove_team_member: "Видалити учасника команди",
        rename: "Перейменувати",
        rename_template: "Перейменувати шаблон",
        renews: "Оновлює",
        replied: "Відповів",
        reply: "Відповідь",
        reply_coverage: "Покриття відповідей",
        replies: "Публічні відповіді",
        replies_disabled: "Публічні відповіді вимкнено",
        reply_to: "Адреса для відповіді",
        replying_on: "Відповідь на",
        request: "Запит",
        request_1_review: "Запросити 1 відгук",
        request_date: "Дата запиту",
        request_n_reviews: "Запросити {count} відгуків",
        request_review: "Запит на Відгук",
        request_reviews: "Запит Відгуки",
        requested: "Запитано",
        requested_review: "Запит на Відгук",
        requests: "Запити",
        requests_left_this_month: "запити, залишені цього місяця",
        requests_remaining: "Залишок запитів",
        require_field: "Обов'язкове поле",
        require_sso: "Вимагати єдиного входу (SSO)",
        required: "Обов'язково",
        reschedule_message: "Повідомлення про перенесення часу",
        resend_invite: "Надіслати запрошення повторно",
        reset_password: "Скинути пароль",
        restore: "Відновити",
        restore_to_defaults: "Відновити налаштування за замовчуванням",
        restore_widget: "Віджет відновлення",
        resubscribe: "Підписатися повторно",
        resubscribe_customer: "Підписатися на клієнта повторно",
        resync: "Повторна синхронізація",
        resync_account: "Повторно синхронізувати обліковий запис",
        resync_now: "Синхронізувати знову зараз",
        retries: "Повторні спроби",
        reveal_above_form: "Показати вище форми",
        reveal_after_submission: "Розкрити після надсилання",
        reveal_below_form: "Показати нижче форми",
        review: "Відгук",
        review_length: "Тривалість Відгук",
        review_link: "Посилання для Відгук",
        review_missed: "Пропущено Відгук",
        review_not_requested: "Відгук не надіслано",
        review_origin: "Цей відгук походить із шаблону",
        review_page: "Сторінка відгуку",
        review_pages: "Сторінки відгуків",
        review_requested: "Запит на відгук надіслано",
        review_spotlight: "Відгук у фокусі",
        review_suggestion: "Пропозиція Відгук",
        review_suggestions: "Пропозиції Відгук",
        review_summary: "Підсумок відгуків",
        review_text: "Текст Відгук",
        review_velocity: "Відгуки на тиждень",
        review_volume: "Обсяг відгуків",
        review_wall: "Стіна відгуків",
        reviewed: "Опубліковано",
        reviews: "Відгуки",
        reviews_ask: "Запитайте",
        reviews_query_failed: "Щось пішло не так. Спробуйте ще раз.",
        reviews_query_placeholder: "Пошукайте відгуки або задайте питання...",
        reviews_with_highlights: "Відгуки з основними моментами",
        reviews_with_replies: "Відгуки з відповідями",
        reviews_without_replies: "Відгуки без відповідей",
        revoke: "Скасувати",
        revoke_client: "Скасувати додаток",
        roadmap: "Дорожня карта",
        role: "Роль",
        sans_serif: "Без засічок",
        save: "Зберегти",
        save_preferences: "Зберегти налаштування",
        save_template: "Зберегти шаблон",
        save_template_as_new: "Зберегти новий шаблон",
        saved: "Збережено",
        schedule: "Розклад",
        schedule_review_request: "Запланувати запит на відгук",
        scheduled: "Заплановано",
        score: "Рахунок",
        search: "Пошук",
        second: "Другий",
        secret_key: "Секретний ключ",
        sections: "Розділи",
        security_code: "Код безпеки",
        select: "Виберіть",
        select_account: "Виберіть обліковий запис",
        select_all: "Вибрати все",
        select_an_option: "Виберіть опцію",
        select_bulk_action: "Виберіть масову дію",
        select_csv_file: "Виберіть CSV файл",
        select_date: "Виберіть дату",
        select_field: "Виберіть поле",
        select_icon: "Виберіть значок",
        select_location: "Виберіть місцезнаходження",
        select_plan: "Виберіть план",
        select_review: "Виберіть Відгук",
        select_source: "Виберіть джерело",
        select_tag: "Виберіть Тег",
        selected: "Вибрано",
        send: "Надіслати",
        send_1_reminder: "Надіслати 1 нагадування",
        send_2_reminders: "Надіслати 2 нагадування",
        send_3_reminders: "Надіслати 3 нагадування",
        send_anytime: "Надсилати будь-коли",
        send_between: "Надіслати між",
        send_message: "Надіслати повідомлення",
        send_retries: "Надіслати {count} Повторні спроби",
        send_retry: "Надіслати {count} Повторити спробу",
        send_test: "Надіслати тест",
        send_thanks: "Надіслати подяку",
        sender_email_address: "Адреса електронної пошти відправника",
        sender_id: "ID відправника",
        sender_name: "Ім'я відправника",
        sending_domain: "Домен-відправник",
        sentiment: "Настрій",
        sent: "Надіслано",
        sent_replies: "Надіслані відповіді",
        serif: "Засічка",
        set_up: "Налаштувати",
        settings: "Налаштування",
        share: "Поділитися",
        share_link: "Поділитися Посилання",
        short: "Короткий",
        shortcode: "Shortcode",
        show: "Показати",
        show_1_suggestion: "Показати 1 пропозицію",
        show_100_results: "Показати 100 результатів",
        show_2_suggestions: "Показати 2 пропозиції",
        show_25_results: "Показати 25 результатів",
        show_3_suggestions: "Показати 3 пропозиції",
        show_4_suggestions: "Показати 4 пропозиції",
        show_5_suggestions: "Показати 5 пропозицій",
        show_50_results: "Показати 50 результатів",
        show_all_reviews: "Показати всі відгуки",
        show_arrows: "Показати стрілки",
        show_avatar: "Показати аватара",
        show_cookie_consent_banner: "Показати банер згоди на використання файлів cookie",
        show_date: "Дата показу",
        show_dots: "Показати крапки",
        show_drop_shadow: "Показати тінь",
        show_field: "Показати поле для наступних оцінок",
        show_full: "Показати повний список зірок",
        show_photo: "Показувати лише фото",
        show_positive_reviews: "Показувати лише позитивні відгуки",
        show_to_public: "Показати публіці",
        showcase: "Showcase",
        showcase_page: "Сторінка Showcase",
        sign_up: "Зареєструватися",
        sign_up_for_free: "Зареєструйтесь безкоштовно",
        sign_up_with_email: "Зареєструватися через email",
        sign_in_with_sso: "Увійти за допомогою єдиного входу",
        sign_up_with_google: "Зареєструватися з Google",
        signature: "Підпис",
        signatures: "Підписи",
        signed_up: "Зареєстровано",
        since: "З",
        size: "Розмір",
        skip: "Пропустити",
        skipped_required_fields: "Обовʼязкові поля пропущено: {fields}",
        slug: "Слаг",
        small: "Малий",
        sms: "SMS",
        smtp_configuration: "Конфігурація SMTP",
        sort: "Сортувати",
        source: "Джерело",
        source_code: "Вихідний код",
        sources: "Джерела",
        space: "Робочий простір",
        space_name: "Назва робочого простору",
        spaces: "Робочі простори",
        split: "Спліт",
        sso: "SSO",
        standard: "Стандартний",
        star: "Зірка",
        star_color: "Колір зірки",
        stars: "Зірки",
        start: "Початок",
        start_free_trial: "Почати безкоштовну пробну версію",
        start_getting_more_reviews: "Почніть отримувати більше відгуків",
        start_over: "Перезапустити",
        status: "Статус",
        store_code: "Код магазину",
        strategy: "Стратегія",
        sub_processors: "Субпідрядники",
        subject: "Тема",
        subscribe: "Підписатися",
        subscription: "Підписка",
        success_page: "Сторінка успіху",
        suggestion: "Пропозиція",
        suggestions: "Пропозиції",
        summary: "Короткий зміст",
        support: "Підтримка",
        suspend: "Призупинити",
        suspend_project: "Призупинити проєкт",
        suspended: "Призупинено",
        svg: "SVG",
        switch_to_smtp_setup: "Перейти до налаштування SMTP",
        switch_to_standard_setup: "Перейти до стандартних налаштувань",
        symbol: "Символ",
        sync: "Синхронізація",
        sync_account: "Синхронізувати обліковий запис",
        sync_now: "Синхронізувати зараз",
        sync_scheduled_time: "Синхронізацію заплановано {time}",
        sync_with_facebook: "Синхронізувати з Facebook",
        sync_with_google: "Синхронізувати з Google",
        synced_time: "Синхронізовано {time}",
        system: "Система",
        system_fonts: "Системні шрифти",
        tag: "Тег",
        tag_1_customer: "Тег 1 Клієнт",
        tag_1_review: "Тег 1 Відгук",
        tag_customers: "Позначити клієнтів",
        tag_existing_reviews: "Тег існуючі Відгуки",
        tag_n_customers: "Тег {count} Клієнти",
        tag_n_reviews: "Тег {count} Відгуки",
        tag_reviews: "Позначити відгуки",
        tag_rule: "Правило Тег",
        tag_with_ai: "Тег за допомогою штучного інтелекту",
        tags: "Теги",
        tags_for_customers: "Теги для клієнтів",
        tags_for_reviews: "Теги для відгуків",
        team: "Команда",
        team_member: "Член команди",
        team_members: "Члени команди",
        template: "Шаблон",
        templates: "Шаблони",
        terms_of_service: "Умови надання послуг",
        test_template: "Тестовий шаблон",
        tests: "Тести",
        text: "Текст",
        text_alignment: "Вирівнювання тексту",
        text_color: "Колір тексту",
        thank_you_messages: "Повідомлення з подякою",
        thanks: "Дякую",
        theme: "Тема",
        third: "Третій",
        time_zone: "Часовий пояс",
        timeframe: "Часові рамки",
        title: "Назва",
        tone: "Тон",
        top: "Верх",
        top_left: "Зверху ліворуч",
        top_right: "Угорі праворуч",
        total_charges: "Загальна сума витрат",
        total_reviews: "Загальна кількість Відгуки",
        trend_mentions: "{count} згадок, {percent}%",
        trigger: "Тригер",
        trigger_charged: "Надіслати запит після стягнення плати",
        trigger_created: "Надіслати запит після реєстрації",
        try_free: "Спробуйте безкоштовно",
        try_it_free: "Спробуйте безкоштовно",
        type: "Тип",
        types: "Типи",
        unarchive: "Розархівувати",
        unarchive_customer: "Розархівувати клієнта",
        underline: "Підкреслення",
        unflag_as_duplicate: "Зняти позначку як дублікат",
        unknown: "Невідомо",
        unlimited: "без обмежень",
        unnamed: "Безіменний",
        unpublish: "Скасувати публікацію",
        unpublished: "Неопубліковано",
        unreplied: "Без відповіді",
        unsent_messages: "Невідправлені повідомлення",
        unsubscribe: "Скасувати підписку",
        unsubscribe_1_customer: "Відписати 1 клієнта",
        unsubscribe_customer: "Відписатися від клієнта",
        unsubscribe_customers: "Відписатися від підписки",
        unsubscribe_n_customers: "Відписати {count} клієнтів",
        unsubscribe_text: "Текст для відписки",
        unsubscribed: "Скасовано підписку",
        unsuspend: "Розблокувати",
        unsuspend_project: "Розблокувати проєкт",
        unverified: "Неперевірено",
        update: "Оновлення",
        update_password: "Оновити пароль",
        update_plan: "Оновити план",
        update_share_template: "Оновити шаблон",
        updated: "Оновлено",
        updates: "Оновлення",
        upgrade: "Оновити тариф",
        upgrade_for_more: "Оновіть, щоб отримати більше",
        upgrade_to_use: "Будь ласка, оновіть програму, щоб користуватися цією функцією",
        upload: "Завантажити",
        upload_csv: "Завантажити CSV",
        upload_icon: "Завантажити значок",
        url: "URL",
        use: "Використання",
        use_filters_for_aggregate: "Використання фільтрів для агрегації",
        user: "Користувач",
        user_id: "ID користувача",
        user_info: "Інформація про користувача",
        username: "Ім'я користувача",
        utc: "UTC",
        validate: "Перевірити",
        validate_customer_email: "Підтвердити електронну пошту клієнта",
        validation: "Перевірка",
        validations: "Валідації",
        value: "Значення",
        verify: "Перевірити",
        verify_email_address: "Підтвердьте адресу електронної пошти",
        view: "Переглянути",
        view_all: "Переглянути всі",
        view_all_features: "Переглянути всі функції",
        view_available_fields: "Переглянути доступні поля",
        view_documentation: "Переглянути документацію",
        view_email_templates: "Переглянути шаблони електронних листів",
        view_review_pages: "Переглянути Сторінки відгуків",
        view_reviews: "Переглянути Відгуки",
        vs_prior: "порівняно з попереднім періодом",
        view_settings: "Налаштування перегляду",
        view_setup_guide: "Переглянути посібник з налаштування",
        view_showcase: "Переглянути вітрину",
        view_strategy: "Переглянути стратегію",
        visibility: "Видимість",
        visible: "Видимий",
        visible_reviews: "Видимі Відгуки",
        visible_to_search_engines: "Видимо для пошукових систем",
        wait_between_reminders: "Зачекайте між нагадуваннями",
        wait_period: "Період очікування",
        webhook: "Вебхук",
        webhooks: "Вебхуки",
        website: "Вебсайт",
        weekly: "Щотижнево",
        weeks: "Тижні",
        widget: "Віджет",
        widgets: "Віджети",
        with_ai: "зі штучним інтелектом",
        wordpress: "WordPress",
        worst_to_best: "Від найгіршого до найкращого",
        would_redirect_to: "Перенаправило б на {url}",
        write: "Написати",
        written_reviews: "Письмові Відгуки",
        year: "рік",
        year_to_date: "Рік до сьогодні",
        yearly: "Щорічно",
        yes: "Так",
        you: "Ви",
        your_referral_link: "Ваше реферальне Посилання"
    },
    landing: {
        announcement: "Керуйте відгуками в {claude} або {chatgpt}",
        counter: "Приєднуйтесь до понад 5 000 місцевих сервісних бізнесів",
        counter_agencies: "Використовують 500+ агентств для керування відгуками",
        counter_ai: "Керуйте відгуками в {claude} або {chatgpt}",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Отримуйте відповіді без входу в іншу панель керування",
            "Дійте на основі репутації в інструментах чату, які ваша команда вже використовує",
            "Зберегти години щотижня, запитуючи замість того, щоб копати"
        ],
        ai_screen_1_subtitle: "Ваша робота з репутації має задовольнити ваші очікування. Запитайте Claude або ChatGPT , на що потрібно відповісти, кого запитати далі або як пройшов тиждень, і отримуйте відповіді в реальному часі, не перемикаючись на інші інструменти.",
        ai_screen_1_title: "Запитайте Claude або ChatGPT",
        ai_screen_2_badge: "Відповіді ШІ",
        ai_screen_2_bullets: [
            "Відповідайте швидше, не звучачи шаблонно",
            "Ніколи не залишайте відгуки без відповіді, коли ви зайняті",
            "Захистіть голос свого бренду в кожній публічній відповіді"
        ],
        ai_screen_2_subtitle: "Кожен відгук без відповіді – це втрачений шанс заслужити довіру. Штучний інтелект створює відповіді, які звучать саме так, як ви, тож ви можете очистити чергу за лічені хвилини та залишатися присутнім для клієнтів без клопоту з написанням.",
        ai_screen_2_title: "Відповідайте без зайвої роботи",
        ai_screen_3_badge: "Пропозиції ШІ",
        ai_screen_3_bullets: [
            "Залучіть більше клієнтів до фінішу",
            "Збирайте конкретні відгуки, якими можна поділитися",
            "Перетворіть приємні візити на відгуки , якими варто похвалитися"
        ],
        ai_screen_3_subtitle: "Більшість людей мають намір залишити відгук, але ніколи цього не роблять. Дайте їм чіткі формулювання своїм голосом, щоб вони мали більше завершеності та щоб більше того, що вони напишуть, було достатньо переконливим, щоб продемонструвати.",
        ai_screen_3_title: "Отримайте більше 5-зіркових відгуки",
        ai_screen_4_badge: "ШІ-тегування",
        ai_screen_4_bullets: [
            "Виявляйте закономірності, перш ніж вони перетворяться на проблеми",
            "Знайдіть теми, які дійсно впливають на рейтинги",
            "Уникайте читання сотень відгуки від руки"
        ],
        ai_screen_4_subtitle: "Вам не потрібно перечитувати кожен відгук, щоб знати, що відбувається. Штучний інтелект організовує відгуки за темами, які вас цікавлять, щоб ви могли швидше виправляти проблеми та подвоювати зусилля щодо того, що подобається клієнтам.",
        ai_screen_4_title: "Дізнайтеся, що кажуть клієнти",
        ai_summary_1_desc: "Створюйте чернетки відповідей Google та Facebook, які відповідають вашому тону, або автоматичні відповіді за розкладом.",
        ai_summary_1_title: "Відповіді ШІ",
        ai_summary_2_desc: "Надайте клієнтам готові пропозиції щодо відгуків, коли вони залишають відгуки на вашій сторінці.",
        ai_summary_2_title: "Пропозиції щодо огляду ШІ",
        ai_summary_3_desc: "Визначайте найкращі фрази з позитивних відгуки у віджетах, демонструйте їх та діліться зображеннями.",
        ai_summary_3_title: "Основні моменти ШІ",
        ai_summary_4_desc: "Застосовуйте теги з визначених вами правил, щоб такі теми, як час очікування або якість обслуговування, залишалися впорядкованими.",
        ai_summary_4_title: "Автоматичне тегування за допомогою штучного інтелекту",
        ai_summary_5_desc: "Отримуйте стислий огляд останніх відгуки з урахуванням кількості, тем і проблем, які варто врахувати.",
        ai_summary_5_title: "Короткі Відгук",
        ai_summary_6_desc: "Виявляйте зростаючу кількість похвал та скарг, що виникають, не читаючи кожен відгук вручну.",
        ai_summary_6_title: "Позитивні та негативні тенденції",
        ai_summary_7_desc: "Знаходьте схожі відгуки поруч із будь-яким відгуком, щоб легко було побачити закономірності та повторення.",
        ai_summary_7_title: "Пов’язані відгуки",
        ai_summary_8_desc: "Ставте запитання простою мовою щодо своїх відгуки та отримуйте відповіді з цитатами, які ви можете відкрити.",
        ai_summary_8_title: "Запитайте ШІ",
        ai_summary_9_desc: "Підключіть Claude, ChatGPT та інші MCP клієнти для керування репутацією в чаті.",
        ai_summary_9_title: "MCP для асистентів",
        ai_summary_10_desc: "Отримуйте звіти про репутацію в режимі реального часу, що охоплюють обсяг, рейтинги, місцезнаходження, відповіді та охоплення.",
        ai_summary_10_title: "Звіти про репутацію",
        ai_summary_11_desc: "Тон керування, ключові слова та власні інструкції, щоб кожен вивід ШІ звучав як ваш бренд.",
        ai_summary_11_title: "Штучний інтелект, що враховує бренди",
        ai_summary_12_desc: "Оцінюйте, наскільки позитивно чи негативно звучать письмові відгуки, поза зірками, і сортуйте те, що потребує уваги.",
        ai_summary_12_title: "Настрій",
        industries: {
            accountants: "Бухгалтери",
            auto_repair: "Автомеханіки",
            chiropractors: "Хіропрактики",
            camps: "Табори",
            cleaning: "Прибиральники",
            contractors: "Підрядники",
            dentists: "Стоматологи",
            doctors: "Лікарі",
            electricians: "Електрики",
            financial_advisors: "Фінансові консультанти",
            hvac: "HVAC-техніки",
            insurance_brokers: "Страхові брокери",
            landscapers: "Ландшафтні дизайнери",
            law_firms: "Юристи",
            locksmiths: "Слюсарі",
            mortgage_brokers: "Іпотечні брокери",
            optometrists: "Оптометристи",
            personal_trainers: "Персональні тренери",
            pest_control: "Дератизатори",
            physical_therapists: "Фізіотерапевти",
            plumbers: "Сантехніки",
            real_estate: "Рієлтори",
            restaurants: "Власники ресторанів",
            salons: "Перукарі",
            self_storage: "Оператори складів",
            spas: "Косметологи",
            preschools: "Дитсадки",
            tour_guides: "Гіди",
            veterinarians: "Ветеринари"
        },
        industries_title: "Управління відгуками для місцевих сервісних бізнесів",
        stat_1_article: "Звіт про дослідження споживачів",
        stat_1_desc: "Люди хочуть отримати більше 100 відгуки , перш ніж довіряти компанії в Інтернеті.",
        stat_1_source: "Козлобородник",
        stat_1_title: "Відгуки завойовують довіру",
        stat_2_article: "Відгук місцевих споживачів",
        stat_2_desc: "Покупці, які порівнюють місцеві компанії, віддають перевагу тим, які відповідають на кожен відгук.",
        stat_2_source: "ЯскравийЛокальний",
        stat_2_title: "Виберіть, хто відповість",
        stat_3_article: "Відгуки, репутація та дохід",
        stat_3_desc: "Невелике підвищення рейтингу може означати реальне збільшення вашого заробітку.",
        stat_3_source: "Гарвардська бізнес-школа",
        stat_3_title: "Дохід на зірку",
        stat_4_article: "Залежність споживачів від результатів пошуку на основі штучного інтелекту",
        stat_4_desc: "Коли люди запитують у ШІ, кого обрати, ваші відгуки допомагають написати відповідь.",
        stat_4_source: "Бейн і компанія",
        stat_4_title: "Покладіться на пошук на основі штучного інтелекту",
        subtitle: "Запитуйте відгуки на автопілоті. Отримуйте більше 5-зіркових оцінок. Рейтинг вищий, ніж у конкурентів.",
        agencies_screen_1_badge: "Портал",
        agencies_screen_1_bullets: [
            "Продавайте брендований портал з кожним контрактом",
            "Залишайте клієнтів у своїй екосистемі, а не через сторонній логін",
            "Виглядайте як компанія-розробник програмного забезпечення, але не створюючи її"
        ],
        agencies_screen_1_subtitle: "Дайте кожному клієнту портал, який виглядає як продукт, який ви створили: ваш логотип, кольори, домен. Потім запакуйте керування відгуками як регулярну послугу, до якої вони заходять щомісяця. Ви не рекомендуєте інструмент. Ви його надаєте.",
        agencies_screen_1_title: "Портал, який вони вважають вашим",
        agencies_screen_2_badge: "Контроль",
        agencies_screen_2_bullets: [
            "Підберіть відповідні функції для стартових, зростаючих та преміум-пакетів",
            "Запросіть потрібних людей і контролюйте, що бачить кожен клієнт",
            "Перевизначення запитів, місць розташування та обмежень для кожного проєкту"
        ],
        agencies_screen_2_subtitle: "Не кожен клієнт має отримувати все. Запрошуйте команди до конкретних проєктів, задавайте ролі та перевизначайте функції й ліміти на акаунт, щоб пакети відповідали вашій тарифікації. Робіть апсейл доступу, коли клієнти ростуть — без кастомних збірок для кожного пакета.",
        agencies_screen_2_title: "Керуйте доступом для кожного клієнта",
        agencies_screen_3_badge: "Штучний інтелект",
        agencies_screen_3_bullets: [
            "Пропонуйте відповіді зі штучним інтелектом, які зберегти клієнтам години щотижня",
            "Зв'яжіть Claude або інших помічників через MCP кожного проекту",
            "Productize AI як преміум-додаток для клієнтів"
        ],
        agencies_screen_3_subtitle: "Не лише керуйте відгуками. Дайте клієнтам ШІ, який пише відповіді, тегує фідбек і працює через Claude чи інших асистентів через MCP-сервер проєкту. Це сучасна можливість, яку агентства можуть пакувати, апсейлити й поновлювати — без контент-команди на кожен акаунт.",
        agencies_screen_3_title: "ШІ, за який клієнти платитимуть",
        agencies_screen_4_badge: "Масштаб",
        agencies_screen_4_bullets: [
            "Керуйте відгуки про багато компаній з одного облікового запису",
            "Додавайте локації, коли ви їх виграєте, з оптовими цінами",
            "Перетворіть кожного нового клієнта на постійний дохід"
        ],
        agencies_screen_4_subtitle: "Одне місце агентства. Десятки бізнесів. Ведіть збір відгуків, відповіді та звітність по всіх локаціях клієнтів з одного хабу й зростайте маржу, додаючи акаунти. Так агентства перетворюють репутацію на масштабований дохід, а не разовий проєкт.",
        agencies_screen_4_title: "Масштабуйтеся на всіх клієнтах",
        agencies_summary_10_desc: "Підключіть Claude або інших помічників для управління проектами, клієнтами та командою.",
        agencies_summary_10_title: "Агентство MCP",
        agencies_summary_11_desc: "Кожен клієнт отримує повний набір інструментів для рецензування: колекцію, штучний інтелект, віджети тощо.",
        agencies_summary_11_title: "Все в бізнесі",
        agencies_summary_12_desc: "Отримайте допомогу від команди, яка розуміє робочі процеси агентства та впровадження клієнтських рішень.",
        agencies_summary_12_title: "Спеціальна підтримка",
        agencies_summary_1_desc: "Клієнти керують репутацією на порталі, який виглядає як продукт, створений вами.",
        agencies_summary_1_title: "Брендований клієнтський портал",
        agencies_summary_2_desc: "Запускайте портал на своєму домені, щоб кожен вхід залишався за вашим брендом.",
        agencies_summary_2_title: "Домен агентства, що користується послугами користувача",
        agencies_summary_3_desc: "Дозвольте клієнтам входити в систему за допомогою вашого постачальника ідентифікаційних даних одним клацанням миші.",
        agencies_summary_3_title: "Єдиний вхід",
        agencies_summary_4_desc: "Запрошуйте клієнтів до певних проєктів та контролюйте, що вони можуть бачити.",
        agencies_summary_4_title: "Запрошення та ролі Клієнт",
        agencies_summary_5_desc: "Обмежте кількість запитів, місць розташування та функцій для кожного проєкту відповідно до ваших пакетів.",
        agencies_summary_5_title: "Перевизначення для кожного проекту",
        agencies_summary_6_desc: "Надайте своїй внутрішній команді повний доступ до кожного клієнтського проєкту.",
        agencies_summary_6_title: "Місця в команді агентства",
        agencies_summary_7_desc: "Почніть з 5 локацій, потім додавайте більше за допомогою оптових цін у міру зростання.",
        agencies_summary_7_title: "Масштаб для кількох локацій",
        agencies_summary_8_desc: "Системні сповіщення надсилаються з домену вашого агентства та для кожного проекту, коли клієнти не додали свої власні.",
        agencies_summary_8_title: "Відправлення білої етикетки",
        agencies_summary_9_desc: "Автоматизуйте проекти, клієнтів та команду за допомогою API агентства.",
        agencies_summary_9_title: "API агентства",
        demo_footer: "Оберіть зручний час. Ми все покажемо і відповімо на ваші запитання.",
        desc_contact: "Маєте запитання або потрібна допомога з чимось? Надішліть повідомлення нижче — ми візьмемо все на себе.",
        mcp_aria: "Демонстрація помічника зі штучним інтелектом, підключена до More Good Reviews через MCP",
        mcp_prompts_aria: "Приклади підказок",
        review_flow_aria: "Карусель карток із запитами на відгуки електронною поштою, сторінкою відгуків, відгуки Google та приватними відгуками",
        review_flow_autopilot: "Працює на автопілоті",
        review_flow_card_email_desc: "Коли ви закінчите роботу з клієнтом, ми автоматично надішлемо вам електронною поштою фірмовий запит із посиланням на вашу сторінку відгуку, яке можна перейти одним дотиком.",
        review_flow_card_email_title: "Надіслати запит",
        review_flow_card_feedback_desc: "Нижчі оцінки спочатку відкривають приватні відгуки, щоб ви могли їх виправити. Клієнти все ще можуть вибрати публічний відгук.",
        review_flow_card_feedback_title: "Зловити жорсткий зворотний зв'язок",
        review_flow_card_google_desc: "Задоволені клієнти мають чіткий шлях до того, щоб залишити публічний відгук у Google , тому похвала відображається там, де шукають нові клієнти.",
        review_flow_card_google_title: "Надішліть похвалу Google",
        review_flow_card_review_desc: "Вони потрапляють на вашу сторінку відгуків, вибирають оцінку, і наступний крок залежить від того, як все пройшло.",
        review_flow_card_review_title: "Клієнт вибирає рейтинг",
        review_flow_next: "Наступний крок",
        review_flow_prev: "Попередній крок",
        review_flow_step_email: "Запит на Відгук",
        review_flow_step_feedback: "або запитайте відгук",
        review_flow_step_google: "Маршрут до будь-якого сайту з Відгук",
        review_flow_step_review: "Запитати Рейтинг",
        review_flow_steps_aria: "Відгук кроків запиту",
        summary_10_desc: "Упорядкуйте клієнтів та відгуки , щоб мати змогу фільтрувати та швидко діяти.",
        summary_10_title: "Тегування Клієнт та відгуків",
        summary_11_desc: "Zapier підключає More Good Reviews до інструментів, які ви вже використовуєте.",
        summary_11_title: "Підключення до будь-якої програми",
        summary_12_desc: "Керуйте репутацією з Claude, ChatGPT та інших клієнтів MCP .",
        summary_12_title: "MCP для асистентів зі штучним інтелектом",
        summary_1_desc: "Заплановані електронні листи та SMS повідомлення з нагадуваннями, в автоматичному режимі.",
        summary_1_title: "Автоматичні запити на перегляд",
        summary_2_desc: "Електронні листи та SMS , що відповідають вашому бренду, стилю та пропозиції.",
        summary_2_title: "Фірмові шаблони",
        summary_3_desc: "Збирайте приватні відгуки або надсилайте людей до Google, Facebook та інших сервісів.",
        summary_3_title: "Сторінки Відгук",
        summary_4_desc: "Коди для друку та повноекранний забір у магазині.",
        summary_4_title: "QR-коди та кіоск",
        summary_5_desc: "Вбудовуйте оцінки та відгуки будь-де на своєму веб-сайті.",
        summary_5_title: "Віджети веб-сайту",
        summary_6_desc: "Публічна сторінка з вашими найкращими відгуки, яку легко опублікувати.",
        summary_6_title: "Showcase Вітрина",
        summary_7_desc: "Імпортувати відгуки та відповідайте з одного місця.",
        summary_7_title: "Синхронізація з Google та Facebook",
        summary_8_desc: "Пропозиції на сторінці, які допомагають клієнтам залишати відгуки.",
        summary_8_title: "Допомога в написанні оглядів на основі штучного інтелекту",
        summary_9_desc: "Створюйте чернетки відповідей, резюме, тенденції та запитуйте ШІ щодо своїх відгуки.",
        summary_9_title: "Відповіді та аналітика ШІ",
        subtitle_agencies_feature_summary: "White label портал, доступ клієнтів, масштаб і автоматизація під вашим брендом.",
        subtitle_ai_feature_summary: "Відповіді, теги, аналітика та помічники, вбудовані у ваш робочий процес репутації.",
        subtitle_feature_summary: "Збір, відображення, ШІ та інтеграції — готові, коли готові ви.",
        subtitle_mcp: "Підключіть Claude, ChatGPT та інші MCP-клієнти й запитуйте про відгуки, локації та outreach природною мовою.",
        subtitle_review_flow: "Просіть відгуки автоматично. Клієнти можуть залишити публічний відгук будь-коли. Приватний фідбек — за бажанням.",
        title: "AI-управління репутацією, щоб",
        title_agencies: "Перетворіть відгуки на",
        title_agencies_feature_summary: "Усе, що потрібно агентствам",
        title_agencies_phrases: {
            branded_product: "брендований продукт, який належить вам",
            recurring_retainers: "щомісячні регулярні ретейнери",
            revenue_stream: "нове джерело доходу"
        },
        title_ai: "Запитайте у свого ШІ",
        title_ai_feature_summary: "Все, що ШІ може зробити для вас",
        title_ai_phrases: {
            weekly_report: "для щотижневого звіту про репутацію",
            send_from_chat: "надсилати запити на відгук",
            next_steps: "для наступних кроків, які потрібно зробити"
        },
        title_contact: "Як ми можемо допомогти?",
        faq_location_pricing_a: "У плані Business ви платите за локацію зі знижками за обсяг (від 59 $\/локація\/міс або 49 $\/міс за річної оплати), і кожна локація включає 5000 запитів на відгуки на місяць. Agency включає 5 локацій і 25 000 запитів; додаткові локації коштують 12 $\/міс і кожна додає 5000 запитів.",
        faq_location_pricing_q: "Як працює ціна за локацію?",
        title_faq: "Поширені запитання",
        title_feature_summary: "Усе в одному пакеті",
        title_footer: "Перестаньте ганятися за відгуками. Почніть їх отримувати.",
        title_footer_ai: "про вашу репутацію",
        title_ltd: "Платіть один раз і користуйтеся вічно завдяки нашій обмеженій за часом пропозиції",
        title_mcp: "Запитайте ШІ про свою репутацію",
        title_review_flow: "Перетворіть чудовий досвід на відгуки",
        title_phrases: {
            autopilot: "запитувати відгуки автоматично",
            google_reviews: "отримувати більше відгуків Google",
            suggested_by_chatgpt: "отримувати пропозиції від ChatGPT"
        },
        title_pricing: "Кожна функція. Просте ціноутворення.",
        title_reviews: "Не вірте нам на слово"
    },
    plans: {
        additional_locations_tooltip: "Додавайте локації з ростом. Business тарифікує кожну локацію від 59 $\/міс (включно з першою) з нижчою річною ставкою. Додаткові локації Agency коштують 12 $\/міс понад 5 включених, і кожна додає 5000 щомісячних запитів.",
        agency: {
            agency_api: "API агентства",
            branded_portal: "Брендований клієнтський портал",
            client_invites: "Запрошення Клієнт , ролі та перевизначення",
            custom_domain: "Домен агентства, що користується послугами користувача",
            everything_in_business: "Все в бізнес-плані",
            locations_included: "5 локацій включено",
            review_requests: "5000 запитів на відгуки\/локація\/місяць",
            sso: "Єдиний вхід (SSO)",
            support: "Спеціальна підтримка клієнтів",
            volume_pricing: "12 $\/міс за додаткову локацію"
        },
        business: {
            ai: "Відповіді, аналітика та запитання ШІ",
            api_mcp: "API та MCP Сервер",
            custom_domains: "Користувацькі домени електронної пошти та сторінки з відгуками",
            google_facebook: "Профіль компанії в Google та Facebook",
            locations_included: "1 місцезнаходження включено",
            review_requests: "{count} запити на перегляд \/ місцезнаходження \/ місяць",
            support: "Спеціальна підтримка клієнтів",
            unlimited_customers: "Необмежена кількість клієнтів",
            volume_pricing: "Ціна за опт від $59\/міс"
        },
        descriptions: {
            agency: "Для агентств, які керують репутацією клієнтів під своїм брендом. П’ять локацій включено, далі 12 $ за додаткову локацію, плюс брендований портал і доступ для клієнтів.",
            business: "Для компаній, які керують власною репутацією. Оплата за локацію з оптовими знижками, а також штучний інтелект, інтеграції та необмежена кількість клієнтів."
        },
        selectors: {
            agency_extras_flat: "Додаткові локації · {price}\/{month} кожна",
            agency_included: "{count} локацій включено",
            agency_tier: "+{from}–{to} локації · {price}\/{month} кожна",
            agency_tier_plus: "+{from}+ локацій · {price}\/{month} кожна",
            business_tier: "{from}–{to} локації · {price}\/{month} кожна",
            business_tier_plus: "{from}+ локацій · {price}\/{month} кожна"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Додати клієнта та запросити відгук",
            customers_to_ask: "Знайдіть клієнтів, щоб попросити їх відгуки",
            location_leaderboard: "Порівняйте ефективність розташування",
            outreach_health: "Перевірити стан доставки розсилок",
            review_digest: "Щотижневий дайджест відгуків",
            send_review_requests: "Надсилайте запити на Відгук масово"
        },
        texts: {
            add_customer_and_ask: "Додайте нового клієнта, використовуючи надані мною контактні дані, а потім заплануйте для нього запит на відгук електронною поштою з двома нагадуваннями.",
            customers_to_ask: "Перелічіть до 50 клієнтів, яких ніколи не просили залишити відгук, відсортованих за датою реєстрації, починаючи з найновіших. Пропустіть усіх, хто відписався. Вкажіть ім'я, електронну пошту та дату реєстрації.",
            import_customer: "Додайте {name} як клієнта. Його електронна адреса — {email}.",
            import_customer_reply: "Додано {name}.",
            import_review: "Додайте 5-зірковий відгук від {name}: Команда працювала професійно, а результати були чудовими.",
            import_review_reply: "Додано 5-зірковий відгук від {name}.",
            location_leaderboard: "Створіть 90-денну таблицю лідерів за місцем розташування з кількістю відгуків, середнім рейтингом, відсотком 5 зірок та тенденцією порівняно з попередніми 90 днями. Сортуйте за рейтингом та позначайте будь-яке падіння нижче 0,2 зірки.",
            outreach_health: "Для електронних листів, надісланих за останні 14 днів, повідомте про загальну кількість надісланих повідомлень, коефіцієнт доставки, коефіцієнт відкриття, коефіцієнт кліків та коефіцієнт невдалих повідомлень. Позначте будь-які аномалії.",
            review_digest: "Підсумуйте всі відгуки за останні 7 днів. Включно з кількістю, середнім рейтингом, розподілом за джерелом та місцем розташування, 3 найпопулярнішими темами та 3 найпопулярнішими проблемами.",
            send_review_requests: "Для клієнтів, які зареєструвалися протягом останніх 30 днів і не отримали запиту, заплануйте запит на Відгук електронною поштою з 2 нагадуваннями. Спочатку покажіть список і зачекайте на моє підтвердження."
        }
    },
    messages: {
        activated: "Успішно активовано.",
        archived: "Успішно архівовано.",
        canceled: "Успішно скасовано.",
        cannot_copy: "Не вдалося скопіювати в буфер обміну",
        cname_active: "Статус CNAME : активний.",
        cname_not_active: "Статус CNAME ще неактивний.",
        connected: "Успішно підключено.",
        cookie_banner_text: "Ми використовуємо файли cookie, щоб покращити ваш досвід. Ви можете налаштувати свої налаштування або прийняти всі.",
        cookie_category_analytics_desc: "Використовується для вимірювання трафіку веб-сайту та використання продукту. Ці файли cookie допомагають нам зрозуміти, як відвідувачі використовують наш сайт.",
        cookie_category_essential_desc: "Завжди активні. Ці файли cookie необхідні для функціонування сайту та не можуть бути вимкнені.",
        cookie_category_functional_desc: "Увімкніть розширені функції, такі як живий чат. Ці файли cookie не відстежують вас у рекламних цілях.",
        cookie_category_marketing_desc: "Використовується для реклами та вимірювання кампаній. До них можуть належати рекламні пікселі та інструменти атрибуції.",
        copied: "Успішно скопійовано.",
        copied_to_all_ratings: "Скопійовано до всіх оцінок. Збережіть, щоб застосувати.",
        created: "Успішно створено.",
        deactivated: "Успішно деактивовано.",
        deleted: "Успішно видалено.",
        disconnected: "Успішно відключено.",
        duplicated: "Успішно дубліковано.",
        error: "Щось пішло не так. Спробуйте ще раз.",
        google_connect_failed: "Нам не вдалося підключитися до Google. Ви можете спробувати ще раз або пропустити цей крок.",
        inquiry_sent: "Дякуємо за запит. Ми зв’яжемося з вами найближчим часом.",
        oauth_consent_intro: "{client} запитує дозвіл на доступ до вашого облікового запису.",
        oauth_request_missing: "Запит на авторизацію OAuth відсутній або термін його дії минув.",
        operation_analytics_rebuild_failed: "Не вдалося створити аналітику.",
        operation_analytics_rebuild_progress: "Створюємо вашу аналітику…",
        operation_analytics_rebuild_success: "Аналітика готова.",
        operation_connection_sync_failed: "Помилка синхронізації {integration_name}.",
        operation_connection_sync_progress: "Синхронізація {integration_name}…",
        operation_connection_sync_success: "Синхронізацію {integration_name} завершено.",
        operation_customer_import_failed: "Імпорт Клієнт не вдалося.",
        operation_customer_import_progress: "Імпорт клієнтів…",
        operation_customer_import_success: "Імпорт Клієнт завершено.",
        operation_review_import_failed: "Не вдалося імпортувати Відгук .",
        operation_review_import_progress: "Імпорт відгуки…",
        operation_review_import_success: "Імпорт Відгук завершено.",
        operation_review_scrape_failed: "Не вдалося імпортувати нещодавній відгук.",
        operation_review_scrape_progress: "Імпортування нещодавніх відгуки…",
        operation_review_scrape_success: "Імпорт нещодавнього відгуку завершено.",
        processed: "Успішно оброблено.",
        published: "Успішно опубліковано.",
        purchased: "Успішно придбано.",
        queued: "Успішно заплановано.",
        refreshed: "Успішно оновлено.",
        removed: "Успішно видалено.",
        resubscribed: "Підписку успішно поновлено.",
        revoked: "Успішно скасовано.",
        saved: "Успішно збережено.",
        scheduled: "Успішно заплановано.",
        sent: "Успішно надіслано.",
        started: "Успішно розпочато.",
        stopped: "Успішно зупинено.",
        sso_failed: "Не вдалося авторизуватися за допомогою SSO.",
        sso_invalid_callback: "Недійсний зворотний виклик SSO.",
        sso_not_configured: "SSO не налаштовано.",
        sso_openid_config_failed: "Не вдалося завантажити конфігурацію OpenID.",
        sso_token_exchange_failed: "Не вдалося завершити обмін токеном SSO.",
        subscribed: "Підписку успішно оформлено.",
        suspended: "Успішно призупинено.",
        synced: "Успішно синхронізовано.",
        unarchived: "Успішно розархівовано.",
        unpublished: "Успішно скасовано публікацію.",
        unscheduled: "Успішно скасовано.",
        unsubscribed: "Підписку успішно скасовано.",
        unsuspended: "Успішно розблоковано.",
        updated: "Успішно оновлено.",
        upgraded: "Успішно оновлено.",
        validated: "Успішно перевірено.",
        verified: "Успішно перевірено."
    },
    notices: {
        agency: "Керуєте агентством? Ви можете використовувати наш продукт під власним брендом, щоб ваші клієнти бачили ваш бренд лише під час користування послугою.",
        ai_tags: "Створіть тег ШІ, щоб відгуки за вашими інструкціями тегувалися автоматично.",
        connected_apps: "Програми, які ви підключаєте через MCP, відображатимуться тут.",
        connector: "Імпортуйте своїх клієнтів з тисяч додатків за допомогою {brand}.",
        customer_messages: "Запит на Відгук для планування повідомлень.",
        customer_reviews: "Запросіть відгук у цього клієнта.",
        customers: "Імпортуйте своїх клієнтів, щоб почати запитувати відгуки.",
        customers_import_yourself: "Імпортуйте своїх клієнтів, щоб почати запитувати відгуки. Ви також можете спочатку імпортувати себе, щоб спробувати процес, перш ніж запрошувати інших.",
        external_links: "Додайте зовнішні посилання на свій клієнтський портал, щоб допомогти продавати свої послуги. Ці посилання будуть відображатися вашим клієнтам на бічній панелі.",
        links: "Додайте на свою сторінку кнопки, щоб залишати відгуки на сторонніх веб-сайтах.",
        locations: "Створіть місцезнаходження, щоб мати змогу пов’язувати відгуки з кількома місцями.",
        ltd: "Активуйте від 1 до 5 кодів доступу для цього облікового запису (максимум 5). Кожен код додає свій щомісячний ліміт запитів та 20 локацій. Щомісячні запити – це сума всіх активованих кодів. Три або більше кодів активують функції агентства. Введіть свої коди нижче, розділивши їх комами.",
        mcp_example_prompts: "Після підключення сервер MCP вставте їх у свій помічник як відправну точку.",
        messages: "Тут відображатимуться всі запити та нагадування, коли від ваших клієнтів надходитимуть запити на відгуки.",
        no_commissions: "Ви ще не заробили жодної комісії.",
        no_payouts: "Виплати надсилаються вручну, як тільки ваш затверджений баланс досягне щонайменше 50,00 доларів США, а ваш банківський рахунок буде підключено.",
        no_projects: "Вам ще не призначено проєкт. Зверніться до адміністратора, щоб отримати доступ.",
        no_referrals: "Ви ще нікого не залучили. Поділіться своїм реферальним посиланням, щоб розпочати.",
        qr_codes: "Створюйте QR-коди з власними кольорами, розташуваннями та теги. Завантажуйте у форматі SVG або PNG.",
        referrals_share_subject: "Мій менеджер репутації на базі штучного інтелекту",
        referrals_share_text: "Моя секретна зброя для отримання відгуків про бізнес: More Good Reviews. Управління репутацією за допомогою штучного інтелекту, яке дійсно працює. Зареєструйтесь за моїм посиланням:",
        review_pages: "Ваш проєкт може мати кілька сторінок з відгуками, де ваші клієнти зможуть залишати відгуки. Це корисно для компаній з кількома локаціями.",
        reviews: "Чекаємо на відгуки від ваших клієнтів.",
        showcase: "Ми тільки починаємо.",
        signatures: "Створіть підпис електронної пошти, щоб скопіювати та вставити його у свою поштову програму.",
        sources: "Створіть джерело, щоб ви могли класифікувати свої відгуки.",
        tag_rules: "Створіть правило для автоматичної категоризації відгуків за допомогою штучного інтелекту.",
        tags: "Створіть тег для категоризації ваших відгуків і клієнтів.",
        unauthorized: "У вас немає дозволу на доступ до цієї сторінки.",
        unsubscribed: "Ви скасували підписку на запити на відгуки.",
        webhooks: "Додайте вебхуки, щоб отримувати сповіщення про події платформи.",
        widgets: "Створюйте віджети для вбудовування відгуків на ваш вебсайт.",
        your_referral_link_text: "Поділіться своїм посиланням, щоб отримувати регулярну комісію {rate}% з кожного платежу від клієнтів, яких ви запрошуєте. Виплати надсилаються вручну, як тільки ваш затверджений баланс досягне щонайменше 50,00 доларів США."
    },
    notification_types: {
        descriptions: {
            imports: "Надіслано після завершення імпорту",
            new_reviews: "Надіслано після отримання відгуків",
            sent_replies: "Надіслано, коли на відгуки автоматично надходять відповіді",
            weekly_reports: "Зведення активності надсилається щотижня"
        },
        names: {
            imports: "Імпорт",
            new_reviews: "Нові Відгуки",
            sent_replies: "Надіслані відповіді",
            weekly_reports: "Щотижневі звіти"
        }
    },
    roles: {
        admin: "Адміністратор",
        manager: "Менеджер",
        operator: "Оператор",
        owner: "Власник",
        super_admin: "Суперадміністратор",
        viewer: "Глядач"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Прийняти запрошення",
        accepting_invite: "Прийняття запрошення",
        access_denied: "Доступ заборонено",
        account: "Обліковий запис",
        actions: "Дії",
        add_custom_field: "Додати власне поле",
        add_ons: "Додатки",
        address: "Адреса",
        agencies: "Агентства",
        agency: "Агентство",
        ai: "Штучний інтелект",
        ai_assistant: "Помічник зі штучним інтелектом",
        ai_highlights: "Основні моменти ШІ",
        ai_replies: "Відповіді ШІ",
        ai_review_suggestions: "Пропозиції Відгук ШІ",
        ai_tags: "Теги ШІ",
        ai_tools: "Інструменти ШІ",
        analytics: "Аналітика",
        api: "API",
        api_key: "Ключ API",
        appearance: "Зовнішній вигляд",
        application_connectors: "З'єднувачі програм",
        attributes: "Атрибути",
        authorize: "Авторизувати",
        auto_tagging: "Автоматичне тегування",
        automate: "Автоматизувати",
        automatic_review_collection: "Автоматичний збір відгуків",
        billing: "Виставлення рахунків",
        branding: "Брендинг",
        change_password: "Змінити пароль",
        clients: "Клієнти",
        cname: "CNAME",
        conditions: "Умови",
        confirmation_message: "Підтверджувальне повідомлення",
        connected_apps: "Підключені програми",
        contact_us: "Зв'яжіться з нами",
        cookie_policy: "Політика щодо файлів cookie",
        cookie_preferences: "Налаштування файлів cookie",
        copy: "Копіювати",
        create_your_account: "Створіть свій обліковий запис",
        crms: "CRM-системи",
        css: "CSS",
        custom_field: "Налаштовуване поле",
        custom_fields: "Налаштовувані поля",
        custom_icons: "Користувацькі значки",
        customer: "Клієнт",
        customer_facing_pages: "Сторінки, орієнтовані на клієнта",
        customers: "Клієнти",
        dashboard: "Панель керування",
        details: "Деталі",
        dmarc: "DMARC",
        domain: "Домен",
        dpa: "Угода про обробку даних",
        dsar: "Запит суб'єкта даних на доступ",
        email_address: "Адреса електронної пошти",
        email_messages: "Повідомлення електронної пошти",
        email_settings: "Налаштування електронної пошти",
        email_usage: "Використання електронної пошти",
        emails: "Електронні листи",
        embed_code: "Вбудувати код",
        example_chat: "Приклад чату",
        examples: "Приклади",
        export: "Експорт",
        external_link: "Зовнішнє Посилання",
        external_link_num: "Зовнішнє Посилання #{num}",
        external_links: "Зовнішні Посилання",
        features: "Функції",
        feedback_form: "Форма відгуку",
        field: "Поле",
        fields: "Поля",
        filters: "Фільтри",
        form_fields: "Поля форми",
        got_access_code: "Маєте код доступу?",
        hipaa: "Заява HIPAA",
        how_it_works: "Як це працює",
        incentive: "Стимул",
        instructions: "Інструкції",
        integration: "Інтеграція",
        integrations: "Інтеграції",
        javascript: "JavaScript",
        latest_reviews: "Останні Відгуки",
        location_leaderboard: "Рейтинг локацій",
        lifetime_deal: "Довічна пропозиція",
        lifetime_deal_terms: "Умови довічної пропозиції",
        limits: "Ліміти",
        link: "Посилання",
        links: "Посилання",
        location: "Розташування",
        location_instructions: "Інструкції для розташування",
        location_picker: "Вибір місця розташування",
        locations: "Місця розташування",
        log_in: "Увійти",
        log_out: "Вийти",
        make_default: "Зробити за замовчуванням",
        manage_limits: "Керування обмеженнями",
        manage_overrides: "Керування перевизначеннями",
        manage_review: "Керувати Відгук",
        mcp_example_prompts: "Приклади підказок",
        mcp_server: "Сервер MCP",
        message: "Повідомлення",
        messages: "Повідомлення",
        meta: "Мета",
        no_clients: "Немає клієнтів",
        no_commissions: "Без комісій",
        no_connected_apps: "Немає підключених програм",
        no_custom_fields: "Без користувацьких полів",
        no_customers: "Немає клієнтів",
        no_links: "Без Посилання",
        no_locations: "Без локацій",
        no_members: "Немає учасників",
        needs_attention: "Потребує уваги",
        no_messages: "Немає повідомлень",
        no_payouts: "Без виплат",
        no_projects: "Без проектів",
        no_qr_codes: "Без QR-кодів",
        no_referrals: "Без рефералів",
        no_review_pages: "Немає Сторінки відгуків",
        no_reviews: "Немає Відгуки",
        no_tags: "Без Теги",
        no_team_members: "Немає членів команди",
        no_template: "Без шаблону",
        no_widgets: "Без віджетів",
        notifications: "Сповіщення",
        options: "Опції",
        overview: "Огляд",
        payment_method: "Спосіб оплати",
        photo: "Фото",
        plans: "Плани",
        powered_by: "Працює на",
        pricing: "Ціноутворення",
        privacy_policy: "Політика конфіденційності",
        profile: "Профіль",
        project: "Проєкт",
        project_limits: "Обмеження проекту",
        project_overrides: "Перевизначення проекту",
        projects: "Проєкти",
        qr_code: "QR-код",
        qr_codes: "QR-коди",
        ratings: "Рейтинги",
        redeem_access_code: "Активувати код доступу",
        redirecting: "Перенаправлення",
        redirects: "Перенаправлення",
        referrals_commissions: "Комісії",
        referrals_payouts: "Виплати",
        referral_program: "Умови реферальної програми",
        reminders: "Нагадування",
        reply: "Відповідь",
        request: "Запит",
        request_options: "Параметри запиту",
        requests: "Запити",
        required: "Обов'язково",
        reschedule_message: "Повідомлення про перенесення часу",
        reset_password: "Скинути пароль",
        resource_limits: "Ліміти ресурсів",
        retries: "Повторні спроби",
        review: "Відгук",
        review_link: "Посилання для Відгук",
        review_page: "Сторінка відгуку",
        review_pages: "Сторінки відгуків",
        review_spotlight: "Відгук у фокусі",
        review_suggestions: "Пропозиції Відгук",
        review_wall: "Стіна відгуків",
        review_velocity: "Відгуки на тиждень",
        reviewer: "Автор відгуку",
        reviews: "Відгуки",
        save_changes: "Зберегти зміни",
        schedule: "Розклад",
        scrape_a_website: "Зібрати з вебсайту",
        search_engines: "Пошукові системи",
        sections: "Розділи",
        select_csv_file: "Виберіть CSV файл",
        select_project: "Виберіть проєкт",
        selecting_project: "Вибір проекту",
        sending_domain: "Домен-відправник",
        sending_limits: "Ліміти надсилання",
        sentiment: "Настрій",
        settings: "Налаштування",
        setup: "Налаштування",
        setup_basics: "Стратегія вашого Запит",
        setup_business: "Почнімо",
        setup_google: "Ваш бізнес-профіль у Google",
        setup_trusted: "Довіряють понад 5000 компаній",
        showcase: "Showcase",
        sign_up: "Зареєструватися",
        signature: "Підпис",
        signatures: "Підписи",
        signing_in: "Вхід",
        single_sign_on: "Єдиний вхід",
        slug: "Слаг",
        sms: "SMS",
        sms_messages: "SMS -повідомлення",
        sms_usage: "Використання SMS",
        smtp_configuration: "Конфігурація SMTP",
        source: "Джерело",
        sources: "Джерела",
        star_mix: "Розподіл оцінок",
        space: "Робочий простір",
        spaces: "Робочі простори",
        stats: "Статистика",
        sub_processors: "Субпідрядники",
        success_page: "Сторінка успіху",
        summary: "Короткий зміст",
        tag: "Тег",
        tag_rule: "Правило Тег",
        tags: "Теги",
        team_members: "Члени команди",
        template: "Шаблон",
        templates: "Шаблони",
        terms_of_service: "Умови надання послуг",
        two_factor_authentication: "Двофакторна автентифікація",
        unable_to_complete_request: "Не вдалося виконати запит",
        unique_review_link: "Унікальне Посилання для Відгук",
        unsent_messages: "Невідправлені повідомлення",
        unsubscribe: "Скасувати підписку",
        update_plan: "Оновити план",
        usage: "Використання",
        user: "Користувач",
        user_info: "Інформація про користувача",
        verify_email_address: "Підтвердьте адресу електронної пошти",
        verifying_email: "Підтвердження електронної пошти",
        visibility: "Видимість",
        webhook: "Вебхук",
        webhooks: "Вебхуки",
        website: "Вебсайт",
        white_label_api: "API білої етикетки",
        white_label_client_portal: "Портал клієнта White Label",
        white_label_image_urls: "URL-адреси зображень White Label",
        white_label_sending_domain: "Домен відправки White Label",
        white_label_widget_tag: "Тег віджета White Label",
        widget: "Віджет",
        widget_num: "Віджет №{num}",
        widgets: "Віджети",
        your_plan: "Ваш план"
    },
    tones: {
        apologetic: "Вибачливий",
        casual: "Повсякденний",
        empathetic: "Співчутливий",
        enthusiastic: "Ентузіазм",
        formal: "Формальний",
        friendly: "Дружній",
        grateful: "Вдячний",
        humorous: "Гумористичний",
        informative: "Інформативний"
    },
    widgets: {
        labels: {
            alignment: "Вирівнювання",
            animation: "Анімація",
            autoplay: "Автовідтворення",
            autoplay_delay: "Затримка автовідтворення",
            avatar: "Аватар",
            background_color: "Колір фону",
            border: "Кордон",
            border_color: "Колір межі",
            border_radius: "Радіус межі",
            border_width: "Ширина межі",
            carousel: "Карусель",
            colors: "Кольори",
            company: "Компанія",
            customer: "Клієнт",
            customer_position: "Позиція клієнта",
            date: "Дата",
            delay: "Затримка",
            design: "Дизайн",
            design_prompt_placeholder: "Приклад: М’який і мінімалістичний, із золотими зірками та закругленими кутами.",
            drop_shadow: "Падаюча тінь",
            duration: "Тривалість",
            filters: "Фільтри",
            font: "Шрифт",
            font_emphasis: "Наголос шрифту",
            font_family: "Сімейство шрифтів",
            font_size: "Розмір шрифту",
            include_hidden: "Включити приховані Відгуки",
            layout: "Макет",
            limit: "Відгуки на сторінку",
            location_ids: "Місця розташування",
            marquee: "Marquee",
            max_slides: "Макс Слайди",
            max_width: "Максимальна ширина",
            name_convention: "Ім'я",
            padding: "Внутрішній відступ",
            pagination: "Пагінація",
            quotes: "Цитати",
            rating: "Рейтинг",
            rating_round: "Округлення",
            rating_round_hundredth: "Найближча сота (4,94)",
            rating_round_tenth: "Найближча десята частина (4,9)",
            review: "Відгук",
            review_chars: "Тривалість Відгук",
            review_count: "Кількість Відгук",
            review_id: "Відгук",
            review_ids: "Відгуки",
            review_ids_for_faces: "Відгуки про Faces",
            reviews: "Відгуки",
            schema: "Схема",
            schema_name: "Назва компанії",
            schema_type: "Тип бізнесу",
            score: "Найнижчий рейтинг",
            show_on_mobile: "Показувати на мобільних пристроях",
            slider: "Слайдер",
            sort: "Сортувати",
            source: "Джерело",
            source_ids: "Джерела",
            source_position: "Позиція джерела",
            speed: "Швидкість",
            star_color: "Колір зірки",
            star_display: "Зоряний дисплей",
            star_size: "Розмір зірки",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Теги",
            take: "Максимальна кількість Відгуки",
            text_color: "Колір тексту",
            truncate: "Скоротити Відгук",
            visible_slides: "Видимі слайди",
            width: "Ширина"
        },
        types: {
            badge: "Значок",
            carousel: "Карусель",
            carousel_dynamic: "Динамічна карусель",
            corner: "Кут",
            corner_dynamic: "Динамічний куточок",
            faces: "Обличчя",
            headline: "Заголовок",
            highlights: "Основні моменти",
            marquee: "Marquee",
            spotlight: "У фокусі",
            wall: "Стіна"
        }
    }
}